(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 30553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = (0,_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(control, controlProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel));

/***/ }),

/***/ 56608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _utils_useControlled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22775);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17812);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = (0,_utils_useControlled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(22124);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/shared/layouts/Navigation.tsx + 3 modules
var Navigation = __webpack_require__(93054);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Benefits.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border-radius: ",
        "px;\n  width: 165px;\n  padding: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f8f8f8;\n  padding: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 343px;\n  justify-content: space-between;\n  margin: 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 33.6px;\n  text-align: center;\n  ",
        " {\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 26.88px;\n  text-align: center;\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-left: 1px solid #d0d0d0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 200px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f8f8f8;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  width: 1074px;\n  margin: auto;\n  padding: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






function Benefits() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    if (mobile) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                display: "flex",
                justifyContent: "center",
                mb: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TileContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: t("benefits.title")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                mb: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: t("benefits.benefit1.number")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                    children: t("benefits.benefit1.text")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: t("benefits.benefit2.number")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                    children: t("benefits.benefit2.text")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mt: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: t("benefits.benefit3.number")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                        children: t("benefits.benefit3.text")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: t("benefits.benefit4.number")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                        children: t("benefits.benefit4.text")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TileContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: t("benefits.title")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDivider, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("benefits.benefit1.number")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                            children: t("benefits.benefit1.text")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("benefits.benefit2.number")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                            children: t("benefits.benefit2.text")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("benefits.benefit3.number")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                            children: t("benefits.benefit3.text")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TileContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("benefits.benefit4.number")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                            children: t("benefits.benefit4.text")
                        })
                    ]
                })
            ]
        })
    });
}
var Paper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var MobileWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3, 2);
});
var FlexRow = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject2());
var Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var VerticalDivider = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject5());
var TileContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7());
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.spacing(3, 0);
});

;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/flaconi.svg
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgFlaconi(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 64,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#flaconi_svg__clip0_13385_2817)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M34.2 14.297c-.084.231-.159.457-.25.676-.362.872-.88 1.636-1.682 2.195-.636.444-1.351.693-2.128.784-.991.116-1.954.024-2.876-.364a4.962 4.962 0 01-1.901-1.396 1.16 1.16 0 00-.054-.059c-.005-.005-.013-.006-.006-.003-.212.265-.406.54-.633.786-.572.618-1.297.964-2.15 1.056-.401.044-.801.04-1.198-.054-.706-.167-1.147-.607-1.388-1.253a3.619 3.619 0 00-.05-.123c-.268.205-.527.423-.807.613a4.761 4.761 0 01-2.074.807c-.678.087-1.33.01-1.937-.32a.415.415 0 00-.19-.036c-2.137-.002-4.275-.001-6.412-.001h-.16c0-.054.003-.095-.001-.135-.006-.06.024-.075.08-.085.638-.11 1.044-.55 1.093-1.19.015-.2.023-.4.023-.599.002-3.995.005-7.99 0-11.986 0-.693-.227-1.319-.715-1.84-.657-.703-1.595-.774-2.368-.436-.478.21-.72.618-.879 1.078-.127.37-.14.751-.132 1.138.013.666.15 1.315.253 1.97.082.52.139 1.044.207 1.566l.01.066h2.162v.652h-2.14v.137l-.006 7.747c0 .301.02.603.131.889.182.463.536.725 1.037.81.03.005.06.012.091.02v.19H.88v-.194c.053-.008.11-.015.167-.028.568-.123.956-.53 1.04-1.1.03-.194.047-.39.047-.585.004-2.582.004-5.164.004-7.746v-.137H.5v-.644h1.638v-.199c-.011-.767.04-1.53.258-2.27C2.909 2.948 3.98 1.66 5.746.96A5.806 5.806 0 018.5.58c.42.042.837.128 1.256.192a.391.391 0 00.149-.005L12.982.01a.415.415 0 01.148-.005c.1.013.133.067.133.17-.005 3.106-.006 6.212-.007 9.318-.002 2.1-.005 4.2 0 6.299 0 .212.02.431.075.637.135.504.494.774 1.022.843.05.006.1.017.15.023.015.002.03 0 .073 0l-.086-.087c-.473-.472-.664-1.041-.641-1.689.033-.965.532-1.667 1.325-2.207.737-.501 1.548-.86 2.393-1.145.686-.231 1.387-.426 2.081-.637l.04-.012c.005-.011.01-.018.01-.025-.004-.765.003-1.53-.018-2.295-.008-.31-.073-.619-.123-.927a.846.846 0 00-.097-.252c-.232-.442-.661-.512-1.076-.374-.183.061-.29.212-.346.378a4.8 4.8 0 00-.19.741 4.739 4.739 0 01-.383 1.296c-.383.801-1.344 1.074-2 .884-.648-.187-1.063-.754-1.032-1.408.03-.625.356-1.083.845-1.456.523-.4 1.131-.597 1.775-.712.865-.155 1.74-.175 2.614-.11.727.056 1.438.193 2.086.537.946.503 1.514 1.27 1.674 2.305.031.203.045.412.046.618.003 1.65 0 3.302.004 4.953 0 .123.013.249.04.369.098.427.43.604.864.469.318-.1.526-.329.714-.577.017-.023 0-.085-.02-.116a5.108 5.108 0 01-.767-1.733 5.917 5.917 0 01-.109-1.83 5.273 5.273 0 011.277-3.036c.862-1.01 1.98-1.62 3.303-1.87a6.562 6.562 0 012.833.067c.603.15 1.164.39 1.63.803.335.297.563.654.63 1.092.121.78-.396 1.445-1.131 1.554a2.471 2.471 0 01-.777-.01c-.54-.096-.875-.447-1.053-.93-.129-.35-.219-.712-.33-1.068-.097-.315-.218-.62-.423-.886-.268-.348-.682-.435-1.078-.228-.193.101-.34.25-.47.419-.33.433-.51.928-.607 1.451a9.113 9.113 0 00-.091 2.656c.068.647.215 1.277.535 1.857.41.743.997 1.295 1.857 1.516 1.308.335 2.67-.064 3.486-1.3.196-.297.279-.576.222-.942-.201-1.284.069-2.49.8-3.582.924-1.378 2.238-2.24 3.911-2.5 1.957-.304 3.697.194 5.111 1.57.791.77 1.257 1.718 1.424 2.79.301 1.934-.294 3.58-1.787 4.903a5.443 5.443 0 01-2.955 1.36c-1.67.215-3.208-.12-4.545-1.146-.82-.63-1.384-1.443-1.731-2.396l-.038-.099h-.001zm3.62-1.773c.032.573.056 1.153.097 1.731.044.613.148 1.217.33 1.807.121.39.272.769.536 1.095.475.585 1.249.594 1.736.02.228-.27.367-.585.471-.914.286-.897.369-1.822.396-2.752.027-.942.025-1.884-.088-2.822-.07-.591-.173-1.176-.38-1.74-.138-.374-.309-.732-.613-1.014-.464-.429-1.145-.401-1.55.079a2.358 2.358 0 00-.34.55c-.306.68-.425 1.405-.492 2.137-.055.603-.07 1.21-.102 1.824v-.001zm-18.122-.64c-.227.105-.437.193-.64.295-.509.256-.953.594-1.279 1.053-.518.73-.587 1.534-.345 2.365.12.41.43.684.851.804.525.151 1.002.018 1.428-.297.025-.018.034-.07.033-.105-.014-.327-.044-.654-.046-.98-.007-.996-.003-1.991-.003-2.986v-.15l.001.002z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M56.943 8.833l-.011-.042c-.007-.122.05-.199.174-.231 1.607-.426 3.213-.853 4.82-1.278a.38.38 0 01.146-.012c.105.015.147.065.146.182-.018 2.792-.032 5.585-.04 8.377 0 .22.026.447.09.657.155.518.58.746 1.084.873.045.012.091.018.15.029v.11l-.005.104h-11.78v-.19c.062-.012.13-.021.196-.037.434-.097.685-.364.754-.83.035-.238.054-.48.055-.72.004-1.82.001-3.64 0-5.46 0-.266-.032-.528-.13-.776-.229-.578-.739-.802-1.34-.723-.51.067-.924.33-1.308.64-.034.027-.053.09-.053.136-.004.543-.003 1.086-.003 1.628 0 1.481-.005 2.963.004 4.444.002.303.027.61.083.908.08.428.365.684.812.768.03.006.06.016.097.025v.102c0 .026-.003.05-.005.083h-6.007v-.179c.213-.084.426-.147.619-.246.383-.197.56-.53.612-.934a2.94 2.94 0 00.024-.371c.002-1.877.002-3.754 0-5.631 0-.274-.056-.537-.186-.785-.21-.397-.559-.581-1.004-.622-.092-.008-.186-.001-.293-.001 0-.057.003-.101 0-.145-.007-.064.021-.09.087-.106.608-.162 1.214-.328 1.822-.491l2.992-.806c.041-.01.084-.028.125-.024.133.011.175.062.175.196V9.033c.24-.207.454-.41.688-.59C51.107 8 51.71 7.597 52.43 7.4c.818-.226 1.64-.258 2.445.049.88.335 1.386.975 1.538 1.869.049.288.068.584.069.876.005 1.832 0 3.664.004 5.496 0 .235.026.474.07.705.053.273.226.485.456.649.299.212.588.198.878-.026.373-.29.52-.676.52-1.123.003-1.538.003-3.076.003-4.614 0-.365.005-.73-.003-1.096a1.614 1.614 0 00-.183-.728c-.21-.398-.559-.583-1.004-.623-.092-.008-.185-.001-.28-.001h-.001zM60.24 6.127c-1.374.001-2.184-1.128-2.208-1.993-.028-1.004.78-2.152 2.183-2.171 1.254-.017 2.224.9 2.23 2.083.004 1.172-.952 2.075-2.205 2.081z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "flaconi_svg__clip0_13385_2817"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h63v18H0z"
  })))));
}
/* harmony default export */ var flaconi = (SvgFlaconi);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/airbnb.svg
var airbnb_g, airbnb_defs;
function airbnb_extends() { airbnb_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return airbnb_extends.apply(this, arguments); }

function SvgAirbnb(props) {
  return /*#__PURE__*/react.createElement("svg", airbnb_extends({
    width: 53,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), airbnb_g || (airbnb_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#airbnb_svg__clip0_13385_2824)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7.741 15.526c-.489.47-.928.94-1.41 1.348-.788.665-1.667 1.102-2.692 1.125-2.494.057-4.28-2.545-3.422-5.097.455-1.357 1.051-2.662 1.632-3.965C2.862 6.666 3.911 4.413 4.95 2.156 5.237 1.534 5.578.95 6.121.548c1.308-.968 3.05-.63 3.894.83.58 1.005 1.07 2.073 1.551 3.14 1.126 2.502 2.225 5.018 3.328 7.531.442 1.006.668 2.046.374 3.16-.618 2.341-2.928 3.434-5.079 2.395-.842-.407-1.535-1.035-2.173-1.743-.101-.112-.192-.235-.275-.336zm-.745-.911l-.293-.418c-.75-1.084-1.412-2.22-1.698-3.562-.238-1.112-.165-2.175.574-3.065.822-.99 2.133-1.27 3.3-.743 1.053.478 1.662 1.56 1.627 2.91-.032 1.258-.512 2.345-1.116 3.377-.3.513-.638 1.002-.97 1.521.74.87 1.51 1.693 2.585 2.062.822.283 1.61.193 2.317-.372.997-.796 1.306-2.118.73-3.435A1049.42 1049.42 0 009.6 2.896a5.205 5.205 0 00-.694-1.16 1.528 1.528 0 00-2.346-.064 3.95 3.95 0 00-.641.993A614.736 614.736 0 002.66 9.78a58.322 58.322 0 00-1.402 3.372c-.383 1.019-.226 1.994.458 2.817.668.804 1.526 1.031 2.478.785 1.184-.306 2.001-1.197 2.8-2.139zm.706-.903c.18-.264.34-.487.487-.72.533-.843 1.015-1.717 1.198-2.74.122-.685.108-1.361-.36-1.92-.499-.592-1.37-.77-2.075-.437-.686.323-1.064 1.03-.988 1.9.132 1.525.919 2.705 1.738 3.916zM46.606 3.37h1.56v3.758c.923-.846 1.897-.835 2.889-.4 1.72.753 2.454 3.125 1.565 4.988-.666 1.395-2.111 2.15-3.455 1.767-.34-.098-.65-.324-.976-.492.034.37-.186.44-.503.42-.35-.021-.703-.004-1.079-.004V3.37zm2.924 8.61c.898-.048 1.565-.557 1.79-1.404.22-.828-.063-1.738-.673-2.171-.717-.509-1.608-.471-2.23.132a.9.9 0 00-.236.542c-.03.542.027 1.09-.019 1.63-.047.543.203.833.6 1.022.242.116.51.168.768.249zM33.049 3.37h1.554v3.655c.052.013.08.029.089.02 1.129-1.146 3.574-.667 4.426 1.377.86 2.067-.072 4.44-1.992 5.02-.882.266-1.73.21-2.507-.562.054.505-.19.544-.496.53-.35-.016-.703-.004-1.074-.004V3.369zm1.569 6.643h-.003c0 .26.024.524-.006.78-.047.398.138.633.413.834.726.525 1.86.358 2.418-.363.557-.719.52-1.934-.08-2.619-.613-.7-1.734-.776-2.453-.172-.204.171-.319.362-.295.658.023.292.005.588.005.882zM23.49 6.98c-.032-.29.152-.377.442-.365.372.016.745.004 1.142.004v6.779c-.454 0-.91.024-1.359-.018-.105-.01-.194-.238-.313-.397-.542.551-1.25.67-2.01.555-1.482-.226-2.55-1.51-2.69-3.226-.186-2.275 1.49-4.108 3.542-3.822.424.06.824.32 1.246.491zm.006 3.01h.003c0-.34.01-.68-.006-1.02a.586.586 0 00-.118-.326c-.623-.74-1.793-.779-2.52-.092-.683.645-.76 1.928-.162 2.713.565.743 1.759.89 2.47.314.233-.19.37-.402.34-.74-.027-.28-.006-.566-.006-.848l-.001-.001zM40.076 6.62c.446 0 .833-.032 1.212.017.138.018.255.23.407.378.63-.578 1.445-.686 2.305-.468 1.01.257 1.69 1.047 1.729 2.168.055 1.546.014 3.096.014 4.67H44.2c-.008-.138-.022-.27-.023-.402l-.003-3.297c0-.125 0-.25-.005-.374-.032-.723-.256-1.1-.731-1.24-.593-.172-1.428.092-1.705.558-.056.093-.058.235-.058.354-.005 1.337-.003 2.674-.004 4.01v.411c-.5 0-.965.002-1.43 0-.225-.002-.161-.195-.162-.325-.004-1.541-.003-3.082-.003-4.623V6.62v.001zM30.337 7.024c.474-.446 1.088-.672 1.787-.541.092.017.235.135.24.212.022.461.01.923.01 1.395-.25-.025-.47-.089-.679-.058a4.256 4.256 0 00-1.02.26c-.317.132-.469.395-.458.822.033 1.313.013 2.629.013 3.943v.324h-1.57V6.62c.455 0 .893-.026 1.325.016.115.01.213.226.352.386zM26.086 6.617h1.552v6.76h-1.552v-6.76zM26.847 5.682c-.599-.014-1.066-.542-1.049-1.186.017-.644.51-1.152 1.101-1.137.596.016 1.058.545 1.041 1.194-.016.662-.484 1.144-1.093 1.13z"
  }))), airbnb_defs || (airbnb_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "airbnb_svg__clip0_13385_2824"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h53v18H0z"
  })))));
}
/* harmony default export */ var airbnb = (SvgAirbnb);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/bain.svg
var bain_g, bain_defs;
function bain_extends() { bain_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bain_extends.apply(this, arguments); }

function SvgBain(props) {
  return /*#__PURE__*/react.createElement("svg", bain_extends({
    width: 61,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bain_g || (bain_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#bain_svg__clip0_13385_2850)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M53.906.494c3.553.92 6.843 4.978 6.58 10.07-.29 5.569-4.828 10.078-10.279 9.309-5.113-.721-8.715-5.933-7.79-11.642C43.355 2.46 48.34-.732 52.802.142c-.247.35-.476.694-.726 1.018-.049.063-.183.067-.276.064-1.031-.029-2.049.068-3.018.476-2.84 1.196-4.558 3.437-5 6.742-.577 4.298 2.2 8.466 6.105 9.273 4.268.881 8.255-2.095 9.068-6.771.652-3.75-1.278-7.577-4.562-9.037-.146-.065-.228-.145-.26-.317-.065-.361-.147-.72-.226-1.096zM28.517 1.269l6.825 6.885V1.43c.621 0 1.21-.003 1.798.007.046 0 .106.085.131.144.023.053.006.126.006.19V13.105l-6.924-6.99v6.704h-1.836V1.269zM5.927 6.762c.198.09.362.15.515.235.919.507 1.427 1.339 1.468 2.453.039 1.066-.333 1.956-1.173 2.562a3.694 3.694 0 01-2.021.7c-1.245.055-2.493.038-3.74.05-.015 0-.03-.011-.067-.026V1.475c.015-.013.028-.034.04-.034 1.288.005 2.579-.104 3.857.143.63.121 1.223.355 1.703.842 1.135 1.149.964 3.248-.335 4.168-.069.049-.14.096-.246.169zm-3.053 4.273c.489 0 .962.022 1.432-.009.26-.017.525-.098.772-.198.534-.216.795-.655.801-1.28.007-.65-.265-1.128-.788-1.359-.717-.317-1.465-.203-2.216-.22v3.066zm0-4.803c.594.018 1.172.048 1.732-.168.504-.195.755-.604.784-1.175.032-.62-.1-1.167-.66-1.462-.588-.309-1.217-.289-1.856-.262v3.067zM14.414 1.176l5.035 11.56c-.076.014-.128.032-.18.032-.59.002-1.181-.004-1.772.005-.148.002-.22-.053-.276-.201-.257-.671-.53-1.335-.786-2.007-.066-.174-.147-.246-.329-.245-1.173.01-2.346.01-3.518 0-.172-.001-.25.068-.315.23-.274.673-.565 1.337-.836 2.011-.064.16-.143.215-.3.212-.572-.01-1.144-.004-1.773-.004l5.05-11.594zm-1.315 7.358h2.512c-.4-1.097-.788-2.155-1.198-3.275L13.1 8.534z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M52.932 2.408l1.667 8.086-6.25-1.564 4.584-6.522zM23.975 1.43v.337c0 3.553-.002 7.106.006 10.66 0 .27-.054.362-.315.35-.538-.025-1.078-.008-1.642-.008-.007-.118-.018-.215-.018-.31-.001-3.572.002-7.143-.005-10.714 0-.245.052-.331.289-.322.546.02 1.094.006 1.685.006zM19.407 17.559c-.224.454-.416.844-.61 1.232-.193.392-.388.782-.6 1.209l-1.188-2.356-.058-.002-.443 2.244h-.723l.976-4.373L18.22 18.4l1.415-2.888c.348 1.482.682 2.9 1.02 4.346h-.768l-.48-2.3zM12.918 19.973c-1.088.05-2.028-.913-2.067-2.114-.042-1.32.825-2.34 2.035-2.395 1.107-.05 2.02.874 2.074 2.1.059 1.323-.815 2.353-2.043 2.41zm-.02-.721c.757-.002 1.339-.648 1.334-1.481-.005-.958-.525-1.594-1.301-1.592-.74.001-1.31.692-1.305 1.58.004.887.523 1.496 1.273 1.494v-.001zM3.878 17.908l-.623 1.028.75.955c-.454-.02-.906.186-1.14-.383-.9.646-1.693.64-2.138 0-.42-.603-.257-1.228.496-1.94-.11-.26-.249-.5-.319-.764-.146-.55.087-1.018.574-1.221.348-.145.7-.144 1.045.01.55.247.743.917.39 1.44-.163.242-.397.428-.629.67l.59.742c.174-.548.508-.699 1.004-.537zm-2.231.123c-.32.216-.471.52-.418.816.05.27.205.426.448.477.288.062.565-.068.727-.344l-.5-.633c-.08-.101-.164-.202-.257-.316zm.346-1.977a.467.467 0 00-.452.499c.008.23.23.607.358.604.192-.004.53-.42.532-.655a.436.436 0 00-.437-.449zM29.667 15.541c.864.87 1.69 1.702 2.566 2.582v-2.516h.706v4.368c-.86-.875-1.69-1.72-2.573-2.615v2.504h-.699v-4.322zM9.98 16.345l-.535.475c-.304-.41-.673-.69-1.173-.634-.361.04-.664.227-.893.54-.483.662-.376 1.751.22 2.267.588.508 1.308.364 1.853-.39l.524.477c-.32.68-1.214 1.046-2.056.855-.88-.199-1.513-1.02-1.57-2.035-.057-1.041.498-1.973 1.368-2.3.825-.308 1.813.01 2.262.745zM21.934 15.535c.586.055 1.138.055 1.67.17.59.13.898.63.892 1.27-.006.604-.32 1.053-.893 1.216-.279.08-.57.1-.905.157v1.147c0 .385 0 .388-.344.384-.485-.004-.417.072-.419-.465-.003-1.166 0-2.331 0-3.497v-.382zm.831.677c-.032.036-.053.049-.053.062-.006.291-.012.582-.013.873-.002.534.023.555.501.455.04-.009.08-.024.12-.039.289-.106.439-.335.43-.654-.007-.326-.162-.548-.462-.625-.175-.045-.359-.051-.522-.072zM28.673 19.879c-.27 0-.492.01-.713-.007-.056-.003-.127-.075-.156-.135a3.16 3.16 0 01-.21-.525c-.059-.215-.175-.265-.367-.256-.35.017-.699.01-1.048.002-.142-.004-.24.029-.28.192-.015.06-.048.115-.073.173-.267.635-.277.64-.969.523l1.9-4.364 1.916 4.396v.001zm-2.406-1.626h.937l-.448-1.22-.489 1.22zM35.297 19.863c0-.506.013-.996-.006-1.485a1.247 1.247 0 00-.138-.53c-.373-.678-.765-1.344-1.15-2.014-.038-.067-.073-.137-.132-.248.269 0 .506-.014.74.008.07.007.148.102.191.178.282.492.555.99.856 1.53.236-.402.49-.752.657-1.146.212-.503.535-.664 1.003-.57.03.005.062.007.129.015-.273.474-.5.952-.798 1.37-.504.71-.714 1.482-.63 2.38.05.53.01.535-.478.528-.073-.001-.146-.01-.243-.017z"
  }))), bain_defs || (bain_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "bain_svg__clip0_13385_2850"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h60v20H0z"
  })))));
}
/* harmony default export */ var bain = (SvgBain);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/doctolib.svg
var doctolib_g, doctolib_defs;
function doctolib_extends() { doctolib_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return doctolib_extends.apply(this, arguments); }

function SvgDoctolib(props) {
  return /*#__PURE__*/react.createElement("svg", doctolib_extends({
    width: 60,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), doctolib_g || (doctolib_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#doctolib_svg__clip0_13385_2868)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M45.38 1.297c-.262 1.5-.517 2.98-.78 4.459-.275 1.55-.56 3.1-.836 4.651-.132.742.111 1.184.696 1.306.681.142 1.315.017 1.872-.372.545-.382.968-.84 1.127-1.53.228-.984.55-1.95.849-2.919.22-.714.688-.999 1.457-.945.207.014.277.074.24.284-.242 1.349-.474 2.7-.708 4.05-.014.08-.022.162-.036.243-.062.37-.13.76.234 1.016.397.278.864.307 1.297.099.543-.261.95-.636 1.105-1.257.802-3.207 1.628-6.408 2.45-9.61.147-.57.67-.856 1.316-.695l-.992 6.32c.457-.115.893-.264 1.342-.333 3.048-.471 4.136 1.716 3.971 3.71-.162 1.968-1.422 3.31-3.411 3.784-.971.231-1.922.28-2.869-.07-.58-.214-1.042-.58-1.43-1.098-.118.12-.22.231-.329.336-.585.56-1.237 1.007-2.096 1.029-.993.025-1.744-.413-2.296-1.195l-.104-.153c-.006-.008-.017-.012-.03-.023-.36.258-.706.536-1.081.772-.914.573-1.9.698-2.95.41-1.198-.329-1.951-1.413-1.699-2.585.29-1.35.637-2.688.992-4.023.44-1.652.913-3.296 1.376-4.942.164-.588.667-.87 1.325-.72h-.002zm8.463 8.826c-.007 1.166.857 1.904 2.04 1.743 1.408-.191 2.325-1.07 2.57-2.46.239-1.36-.949-2.426-2.333-2.094-1.3.312-2.27 1.509-2.278 2.812zM34 12.687c-.568.48-1.158.893-1.906 1.016-1.757.288-3.825-.833-3.367-3.164.354-1.803.9-3.57 1.36-5.353.026-.098.05-.196.084-.334-.276 0-.524.003-.772 0-.82-.011-1.37-.225-1.069-1.506.596 0 1.209-.022 1.818.009.359.018.512-.08.596-.433.17-.726.4-1.44.616-2.156.17-.566.676-.84 1.33-.696l-.578 3.25c.136.01.255.022.376.025 1.333.042 2.667.08 4 .124.314.01.381.12.266.41-.114.289-.35.431-.653.465-.957.109-1.914.212-2.871.308-.38.038-.76.058-1.141.078-.173.01-.257.077-.289.25-.347 1.86-.715 3.716-1.046 5.579-.143.804.403 1.334 1.229 1.177.386-.074.747-.306 1.096-.504.08-.046.103-.248.092-.372-.144-1.612.409-2.963 1.732-3.938 1.248-.92 2.686-1.201 4.2-.692 1.087.365 1.609 1.232 1.825 2.264.574 2.746-1.432 5.128-4.33 5.17-.91.012-1.734-.293-2.597-.976zm.947-2.9c0 1.369 1.105 2.187 2.48 1.835 1.171-.3 2.054-1.453 2.06-2.69.006-1.14-.962-1.967-2.127-1.815-1.36.177-2.412 1.342-2.413 2.67zM2.983 1.278c-.698.038-1.396.079-2.094.113-.376.018-.649-.146-.83-.463C-.038.754-.03.645.206.608 1.95.338 3.69.004 5.465 0c1.54-.003 3.037.26 4.44.897 1.946.884 2.963 2.383 2.952 4.453-.011 2.168-.676 4.152-2.116 5.848-1.303 1.534-3.029 2.36-5.038 2.656-1.37.202-2.744.184-4.117.011-.021-.002-.043-.002-.064-.005-.87-.125-1.055-.381-.83-1.195.83-3 1.663-6 2.5-8.998.162-.582.527-.83 1.105-.797.192.011.256.063.218.262-.257 1.336-.5 2.674-.75 4.012-.256 1.367-.519 2.734-.77 4.102-.111.605.037.765.666.775 1.154.018 2.286-.107 3.35-.57 1.893-.827 2.968-2.307 3.529-4.184.26-.875.38-1.768.172-2.667-.305-1.32-1.25-2.096-2.483-2.592-1.382-.557-2.849-.674-4.324-.728-.307-.012-.615-.002-.922-.002zM20.9 10.741c-.406.071-.641.253-.814.61-1.004 2.077-3.834 2.96-5.9 1.833-.928-.505-1.43-1.347-1.522-2.356-.292-3.185 2.584-5.36 5.57-4.71 1.218.266 1.83 1.139 2.153 2.239.048.164.076.334.135.598.25-.264.462-.466.649-.688.352-.42.653-.887 1.042-1.272 1.085-1.079 2.925-1.204 4.198-.332.164.112.194.209.092.38-.27.448-.398.504-.892.35-.997-.313-2 .06-2.537.998-.592 1.039-.547 2.106.023 3.14.344.624 1.1.88 1.905.716.707-.145 1.294-.488 1.792-.988.098-.098.23-.204.36-.223.385-.053.595.22.454.567-.51 1.254-1.47 1.994-2.836 2.174-1.289.169-2.382-.249-3.194-1.256-.414-.514-.592-1.123-.677-1.78zm-6.44-.981c-.015 1.11.62 1.848 1.766 1.922.409.026.873-.09 1.243-.271 1.031-.506 1.472-1.419 1.524-2.484.056-1.133-.96-1.962-2.123-1.81-1.346.176-2.393 1.325-2.41 2.643z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M50.795 3.451c-.004.62-.48 1.077-1.13 1.08-.496.003-.833-.323-.834-.807 0-.704.451-1.16 1.147-1.16.511 0 .82.334.816.886v.001z"
  }))), doctolib_defs || (doctolib_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "doctolib_svg__clip0_13385_2868"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v14H0z"
  })))));
}
/* harmony default export */ var doctolib = (SvgDoctolib);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/ey.svg
var ey_g, ey_defs;
function ey_extends() { ey_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ey_extends.apply(this, arguments); }

function SvgEy(props) {
  return /*#__PURE__*/react.createElement("svg", ey_extends({
    width: 30,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ey_g || (ey_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#ey_svg__clip0_13385_2768)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M.5 14.167c2.71 0 5.349-.005 7.988.01.184 0 .45.099.538.233.594.915 1.15 1.851 1.801 2.915H4.985v2.253h5.218v2.94h-5.22v2.38h5.665c1.115 0 1.673.527 1.673 1.58V28H.5V14.167zM10.417 14.09c1.506 0 2.973-.02 4.437.025.206.006.464.306.591.525.738 1.283 1.444 2.582 2.217 3.978.764-1.377 1.494-2.637 2.161-3.926.24-.462.524-.634 1.064-.62 1.328.035 2.657.011 4.143.011-.206.364-.333.607-.477.84-1.422 2.312-2.863 4.613-4.256 6.94-.24.4-.38.906-.395 1.367-.048 1.537-.018 3.075-.018 4.655h-4.442c0-.695-.074-1.412.014-2.111.286-2.278-.378-4.255-1.742-6.142-1.209-1.672-2.186-3.494-3.262-5.251-.024-.039-.013-.097-.034-.29h-.001zM.5 9.891L29.5 0v5.1L.5 9.89z"
  }))), ey_defs || (ey_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "ey_svg__clip0_13385_2768"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h29v28H0z"
  })))));
}
/* harmony default export */ var ey = (SvgEy);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/getyourguide.svg
var getyourguide_g, getyourguide_defs;
function getyourguide_extends() { getyourguide_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return getyourguide_extends.apply(this, arguments); }

function SvgGetyourguide(props) {
  return /*#__PURE__*/react.createElement("svg", getyourguide_extends({
    width: 29,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), getyourguide_g || (getyourguide_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#getyourguide_svg__clip0_13385_2846)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M3.275 0C1.43 0 .048 1.195.048 2.934v.9c0 1.715 1.302 2.98 2.92 2.98a2.935 2.935 0 002.337-1.126v.986h1.334V3.066H3.032v1.226h1.965c-.161.675-.832 1.195-1.69 1.195-.857 0-1.771-.675-1.771-1.653v-.9c0-.923.72-1.606 1.73-1.606.785 0 1.489.411 1.723 1.017l1.415-.481C6.017.722 4.74 0 3.274 0zM7.73.132v6.542h4.367v-1.32H9.26V4.051h2.531V2.739H9.26V1.451h2.79V.132H7.732zm5.022 0v1.32h5.176V.132h-5.176zm1.82 1.839v1.218H16.1V1.971h-1.528zm0 1.738v1.218H16.1V3.71h-1.528zm0 1.746v1.218H16.1V5.455h-1.528zm-4.545 2.142V8.97c1.116 0 2.005.885 2.005 2.026 0 1.14-.89 2.025-2.005 2.025-1.116 0-2.006-.877-2.006-2.025H6.453c0 1.909 1.585 3.406 3.575 3.406 1.99 0 3.574-1.497 3.574-3.406s-1.585-3.4-3.574-3.4zM0 7.729l2.572 4.074v2.468H4.1v-2.483L6.664 7.73H4.94l-1.617 2.677L1.73 7.73 0 7.729zm14.54 0v3.997c0 1.536 1.197 2.677 2.847 2.677s2.847-1.14 2.847-2.677V7.729h-1.521v4.02c0 .752-.566 1.311-1.326 1.311-.76 0-1.327-.559-1.327-1.311v-4.02h-1.52zm7.65 0l-.864.869.792.799-.776.815.784.8-.777.815.793.806-.785.807.841.838h1.594l-.858-.846.785-.815-.793-.8.785-.814-.792-.8.775-.815-.792-.799.873-.861H22.19v.001zm1.99 0v1.327h.833c.422.04.744.381.744.788a.804.804 0 01-.744.788h-.832v1.257l1.657 2.383h1.86l-1.86-2.5c.91-.256 1.537-1.053 1.545-1.962 0-1.188-1.019-2.08-2.313-2.08h-.89v-.001zm-15.304.039c-.436-.002-.792.334-.797.752v.016c.005.419.36.755.797.753.435-.002.788-.342.788-.76 0-.419-.353-.759-.788-.76v-.001zm-1.42 1.366c-.446.004-.805.355-.8.783v.016a.743.743 0 00.237.535c.15.141.353.22.563.217h.017c.446-.005.805-.356.8-.784-.005-.428-.37-.772-.817-.768zm-4.181 6.052c-1.844 0-3.227 1.195-3.227 2.934v.9c0 1.715 1.302 2.98 2.92 2.98a2.935 2.935 0 002.337-1.125v.985h1.334v-3.608H3.032v1.226h1.965c-.161.676-.832 1.195-1.69 1.195-.857 0-1.771-.675-1.771-1.652v-.9c0-.924.72-1.607 1.73-1.607.785 0 1.489.411 1.723 1.017l1.415-.481c-.388-1.14-1.666-1.862-3.13-1.862v-.002zm11.314.125v.613h.008v.023c0 .606.38.931.607 1.126.226.194.161.147.161.201 0 .055 0 .07-.161.21-.162.14-.574.497-.599 1.055v.101c.024.559.38.87.599 1.055.218.186.161.148.161.202 0 .055 0 .07-.161.21-.162.14-.607.52-.607 1.125v.015h-.008v.613h1.537v-.457c0-.131.049-.258.137-.357l.025-.023c.226-.195.607-.52.607-1.126 0-.605-.38-.923-.607-1.125-.226-.202-.162-.14-.162-.186 0-.046.024-.062.17-.186h-.008c.226-.194.607-.52.607-1.125 0-.606-.38-.924-.607-1.118l-.024-.03a.502.502 0 01-.138-.35v-.465h-1.537v-.001zm3.267 0v6.55h2.249c2.11 0 3.607-1.39 3.607-3.268s-1.497-3.282-3.607-3.282h-2.249zM7.7 15.327v3.988C7.699 20.86 8.904 22 10.554 22s2.847-1.14 2.847-2.685v-3.988h-1.52v4.02c0 .752-.567 1.303-1.327 1.303s-1.326-.551-1.326-1.304v-4.02H7.7zm16.926 0v6.533H29V20.55h-2.838v-1.311h2.523v-1.304h-2.523v-1.296h2.79v-1.311h-4.327zm-5.232 1.303h.833c1.14 0 1.916.846 1.916 1.963s-.777 1.955-1.916 1.955h-.833V16.63z",
    fill: "#C3C6C5"
  }))), getyourguide_defs || (getyourguide_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "getyourguide_svg__clip0_13385_2846"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h29v22H0z"
  })))));
}
/* harmony default export */ var getyourguide = (SvgGetyourguide);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/jll.svg
var jll_g, jll_defs;
function jll_extends() { jll_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return jll_extends.apply(this, arguments); }

function SvgJll(props) {
  return /*#__PURE__*/react.createElement("svg", jll_extends({
    width: 52,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jll_g || (jll_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#jll_svg__clip0_13385_2837)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.271 0c-1.916 1.34-3.09 3.198-3.863 5.305-.912 2.481-1.082 5.051-.815 7.658.115 1.127.353 2.228.71 3.308.03.09.048.209.014.293-.26.648-.535 1.291-.805 1.935l-.108.003c-.224-.46-.47-.912-.666-1.383-.95-2.289-1.247-4.678-1.126-7.126.093-1.892.474-3.726 1.261-5.467.225-.497.485-.982.77-1.45.13-.21.13-.347-.008-.544-.32-.452-.311-.46.051-.892.133-.159.274-.311.434-.492l.604.508 1.021-.858-.965-.776a7.635 7.635 0 00-1.93 1.75C7.225 3.813 6.387 6.152 6.1 8.691c-.28 2.474-.16 4.922.579 7.321.4 1.297.976 2.516 1.786 3.623.122.167.12.278-.012.424-.21.23-.405.473-.642.754-.264-.253-.524-.474-.752-.722-1.304-1.416-2.07-3.1-2.5-4.923-.853-3.634-.717-7.216.792-10.69.609-1.404 1.477-2.633 2.741-3.57.025-.019.04-.047.085-.099-.265-.221-.532-.438-.79-.663C7.248.025 7.14.053 7 .153a8.668 8.668 0 00-1.808 1.77C3.844 3.672 3.047 5.646 2.693 7.785c-.464 2.804-.381 5.59.482 8.322.627 1.985 1.62 3.782 3.225 5.191.938.824.67.828 1.624-.008 1.692-1.484 2.718-3.38 3.307-5.488.936-3.348.892-6.696-.12-10.03a.958.958 0 01.01-.583c.225-.593.493-1.17.744-1.754a8.68 8.68 0 00.127-.008c.295.664.631 1.313.875 1.995.867 2.427 1.074 4.928.812 7.474-.204 1.984-.723 3.883-1.759 5.613-.306.51-.337.874.087 1.276.015.013.022.034.056.091l-.781.942-.638-.528-1.011.86.912.758-.032.093c-.503-.13-1.006-.261-1.51-.386-.093-.023-.207-.053-.287-.022-1.818.735-3.373.196-4.758-.97-1.326-1.117-2.09-2.597-2.658-4.175C.904 15.073.642 13.652.558 12.2.552 12.098.52 12 .5 11.9v-1.85c.066-.558.117-1.118.2-1.674.302-2.02.915-3.938 2.104-5.644.823-1.18 1.85-2.138 3.31-2.556.23-.066.465-.118.698-.176h.701c.454.131.907.263 1.361.392a.294.294 0 00.15.001C9.477.265 9.93.132 10.382 0h.638c.474.13.947.262 1.42.39.038.01.085.013.122.002.464-.129.927-.26 1.39-.392h.319z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.653 0c.234.058.47.108.701.176 1.458.424 2.492 1.373 3.32 2.557 1.171 1.673 1.791 3.548 2.093 5.53a17.451 17.451 0 01-.002 5.435c-.368 2.293-1.1 4.453-2.67 6.266-.884 1.02-1.966 1.75-3.367 1.946-.646.09-1.27-.029-1.87-.25a.94.94 0 00-.692-.009c-.424.147-.873.228-1.335.342.01-.08.005-.108.015-.116 2.083-1.535 3.275-3.629 3.996-6.005.633-2.084.754-4.22.602-6.377-.142-1.997-.605-3.915-1.546-5.707-.302-.574-.663-1.119-1.017-1.712l.766-.912c.862.693 1.499 1.518 2.014 2.437.85 1.516 1.35 3.144 1.578 4.845.341 2.543.232 5.064-.551 7.53-.503 1.586-1.21 3.071-2.412 4.289-.3.302-.637.57-.99.884.287.23.57.476.875.69.063.044.239.005.319-.052 1.035-.752 1.832-1.707 2.495-2.771 1.069-1.717 1.658-3.589 1.907-5.568.306-2.43.209-4.84-.467-7.209-.58-2.03-1.557-3.859-3.094-5.376-.309-.307-.656-.577-.986-.863h.318zM32.266 4.396h5.78l.028.508-.572.088c-.623.091-.885.37-.922.983-.004.072-.01.144-.01.216.002 3-.007 6 .012 8.999.006.975.218 1.203 1.213 1.302.564.055 1.15.032 1.711-.052.699-.105 1.196-.541 1.55-1.13.245-.41.29-.423.823-.315-.01.058-.01.12-.03.175-.257.727-.51 1.455-.785 2.176-.035.092-.182.204-.278.204-2.772.01-5.545.009-8.318.007-.05 0-.1-.017-.168-.03v-.484c.122-.026.242-.055.364-.077.61-.11.879-.398.922-.999.012-.164.013-.328.013-.492-.002-3.114 0-6.226-.007-9.34-.002-.782-.289-1.092-1.093-1.202-.402-.055-.139-.331-.234-.538v.001zM41.879 17.56c0-.154-.002-.256 0-.36 0-.05.006-.1.008-.145 1.195-.309 1.304-.398 1.312-1.563.019-3.052.005-6.104.002-9.156 0-.123-.014-.246-.028-.368-.073-.665-.375-.957-1.07-1.037a43.385 43.385 0 01-.204-.022V4.4h5.748V4.9c-.273.05-.544.093-.81.15-.361.079-.566.312-.624.657a4.038 4.038 0 00-.065.673c-.004 2.805-.005 5.61 0 8.416 0 .266.027.533.062.797.07.528.268.795.806.842.691.06 1.4.077 2.088-.002.687-.08 1.177-.527 1.527-1.105.26-.43.28-.435.87-.335-.29.814-.571 1.625-.878 2.428-.029.075-.217.132-.331.133-2.232.007-4.463.005-6.694.005h-1.72zM22.772 14.992h.579c.247.368.427.737.701 1.021.53.547 1.215.696 1.957.491.71-.197.974-.752 1.071-1.393.06-.394.075-.797.076-1.196.005-2.445 0-4.89 0-7.335 0-.123-.002-.247-.004-.37-.016-.862-.233-1.11-1.1-1.261-.29-.05-.413-.232-.372-.546h5.727v.477c-.03.017-.047.034-.065.037-.907.11-1.153.344-1.238 1.22-.03.307-.022.617-.022.924-.002 2.373.009 4.746-.01 7.12a5.608 5.608 0 01-.192 1.395c-.363 1.35-1.45 2.217-2.89 2.29-.608.03-1.239.024-1.831-.095-1.381-.277-2.07-1.22-2.342-2.5-.017-.08-.026-.161-.046-.28h.001z"
  }))), jll_defs || (jll_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "jll_svg__clip0_13385_2837"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h51v22H0z"
  })))));
}
/* harmony default export */ var jll = (SvgJll);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/meta.svg
var meta_g, meta_defs;
function meta_extends() { meta_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return meta_extends.apply(this, arguments); }

function SvgMeta(props) {
  return /*#__PURE__*/react.createElement("svg", meta_extends({
    width: 67,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), meta_g || (meta_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#meta_svg__clip0_13385_2758)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M10.212 6.703c-.713 1.26-1.291 2.447-2.023 3.525-.73 1.074-1.49 2.194-2.461 3.013-1.788 1.51-4.43.655-5.257-1.578-.772-2.08-.487-4.167.096-6.229C1.061 3.69 1.866 2.12 3.3.986 4.932-.304 6.887-.338 8.525.934c.685.532 1.271 1.2 1.794 1.704l1.805-1.577c1.5-1.304 3.252-1.417 4.846-.229.551.412 1.076.926 1.457 1.502 1.71 2.583 2.3 5.452 1.754 8.521-.248 1.4-.963 2.532-2.396 2.94-1.412.403-2.711.063-3.652-1.072-.91-1.097-1.67-2.33-2.457-3.53-.498-.757-.923-1.564-1.464-2.491zm8.184 2.08l-.043-.005c-.013-.254-.014-.51-.042-.763-.225-2.032-.68-3.97-2.216-5.432-1.008-.96-2.186-.959-3.174.025-.389.387-.704.852-1.07 1.263-.296.332-.304.612-.057 1.005.846 1.346 1.638 2.728 2.473 4.082.424.687.868 1.364 1.354 2.003.413.543 1.001.75 1.661.577.607-.16.858-.655.945-1.244.074-.502.114-1.008.168-1.513l.001.002zM2.24 8.857c.069.528.084 1.07.217 1.58.3 1.143 1.408 1.516 2.334.809.255-.195.506-.424.685-.69A234.13 234.13 0 008.21 6.374c1-1.565.967-1.75-.4-3.062-1.494-1.43-2.993-1.237-4.086.537-.94 1.525-1.338 3.217-1.486 5.008zM31.466 8.401c.661-1.225 1.26-2.331 1.855-3.44.696-1.293 1.409-2.577 2.074-3.887.237-.465.51-.656 1.035-.65C38.3.443 38.3.421 38.3 2.341c0 3.493-.016 6.985.013 10.478.005.679-.145.945-.858.91-1.505-.077-1.307.182-1.313-1.341-.01-2.749-.003-5.497-.003-8.495-.238.357-.364.518-.46.695-.994 1.823-2.015 3.63-2.954 5.483-.35.69-.873.52-1.39.547-.502.027-.928.027-1.23-.566-.896-1.76-1.866-3.482-2.807-5.217-.14-.255-.284-.508-.565-.715-.01.24-.031.481-.031.723-.003 2.677-.023 5.354.013 8.03.008.673-.175.885-.834.855-1.517-.068-1.292.184-1.297-1.347-.01-3.721.007-7.443-.014-11.165-.003-.582.151-.728.736-.807 1.402-.185 2.184.346 2.782 1.674.852 1.892 1.93 3.675 2.914 5.504.128.238.266.47.464.817v-.003zM64.802 4.777c.144-.374.22-.885.368-.908.55-.085 1.124-.024 1.685.027.06.006.135.306.136.469.008 2.932.002 5.864.01 8.795 0 .376-.112.585-.51.551a2.968 2.968 0 00-.446 0c-.697.05-1.374.08-1.084-1.036-.154.035-.242.026-.278.066-1.784 2-5.54 1.596-6.805-1.676-.882-2.287-.3-5.11 1.376-6.52 1.566-1.317 3.763-1.292 5.324.06.07.06.15.113.224.17v.002zm.172 3.987c-.068-.575-.022-1.197-.227-1.714-.462-1.162-1.45-1.526-2.602-1.498-1.058.026-2.015.663-2.28 1.744-.193.79-.267 1.68-.129 2.477.322 1.849 1.893 2.66 3.613 1.999 1.233-.476 1.562-1.109 1.624-3.008zM42.307 9.58c.096 2.491 2.45 3.09 5.592 1.45l1.051 1.307c-1.11 1.15-2.447 1.549-3.915 1.601-2.97.107-5.063-2.153-4.976-5.36.086-3.168 2.281-5.247 5.249-4.968 1.958.184 3.448 1.727 3.78 3.915.207 1.37-.35 2.055-1.67 2.055H42.307zm4.745-1.674c-.019-1.544-.981-2.496-2.407-2.445-1.324.048-2.357 1.126-2.313 2.445h4.722-.002zM51.625.934c.63 0 1.17-.036 1.7.025.138.015.338.329.348.514.04.734.016 1.47.016 2.33.772 0 1.507.049 2.232-.013.789-.066.667.46.667.934 0 .472.12.998-.663.93-.707-.058-1.424-.011-2.106-.011 0 1.827-.034 3.571.018 5.312.02.684.55.997 1.182 1.038.485.031.975.007 1.455.007.034.057.08.098.081.14.058 1.808.286 1.67-1.569 1.78-2.032.118-3.246-1.108-3.317-3.229-.046-1.373-.02-2.749-.025-4.123-.002-.273 0-.546 0-.929-.52 0-.958-.011-1.395.004-.36.012-.566-.105-.54-.517.017-.279-.059-.58.024-.834.063-.194.29-.438.472-.467.432-.069.882-.023 1.42-.023V.934z"
  }))), meta_defs || (meta_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "meta_svg__clip0_13385_2758"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h67v14H0z"
  })))));
}
/* harmony default export */ var meta = (SvgMeta);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/airbnb.svg
var mobile_airbnb_g, mobile_airbnb_defs;
function mobile_airbnb_extends() { mobile_airbnb_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_airbnb_extends.apply(this, arguments); }

function airbnb_SvgAirbnb(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_airbnb_extends({
    width: 38,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_airbnb_g || (mobile_airbnb_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#airbnb_svg__clip0_13385_3109)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5.55 10.35c-.35.314-.665.627-1.012.9-.564.443-1.195.734-1.93.75C.822 12.037-.46 10.303.156 8.6c.327-.904.754-1.774 1.17-2.643.727-1.514 1.479-3.016 2.224-4.52.206-.415.45-.805.84-1.072.937-.646 2.187-.421 2.791.553.416.67.768 1.382 1.113 2.093.807 1.668 1.595 3.345 2.386 5.02.316.672.478 1.365.268 2.107-.443 1.561-2.1 2.29-3.642 1.597-.603-.271-1.1-.69-1.558-1.162-.073-.075-.138-.156-.197-.224zm-.534-.607l-.21-.278c-.538-.723-1.013-1.48-1.218-2.375-.17-.741-.118-1.45.412-2.043.59-.66 1.53-.847 2.365-.495.756.318 1.192 1.04 1.167 1.94-.022.838-.366 1.563-.8 2.251-.215.342-.457.668-.695 1.014.53.58 1.083 1.128 1.853 1.374.59.189 1.155.129 1.662-.247.714-.531.936-1.413.523-2.29A677.216 677.216 0 006.882 1.93a3.429 3.429 0 00-.497-.774 1.15 1.15 0 00-1.682-.042 2.62 2.62 0 00-.46.662 396.671 396.671 0 00-2.336 4.742A37.418 37.418 0 00.903 8.768c-.275.678-.163 1.328.328 1.877.479.536 1.094.688 1.776.524.85-.204 1.435-.798 2.008-1.426zm.506-.602c.13-.176.244-.324.35-.479.382-.563.727-1.145.858-1.827.088-.457.078-.908-.259-1.28-.357-.395-.98-.513-1.487-.292-.492.216-.763.687-.708 1.267.094 1.016.658 1.804 1.246 2.61v.001zM33.416 2.247h1.118v2.505c.662-.564 1.36-.556 2.071-.267 1.234.502 1.76 2.084 1.123 3.325-.478.93-1.514 1.434-2.478 1.178-.244-.064-.465-.215-.7-.327.025.247-.132.293-.36.28-.251-.015-.504-.003-.773-.003V2.247h-.001zm2.096 5.74c.644-.032 1.122-.372 1.283-.936.158-.552-.045-1.159-.482-1.448-.514-.339-1.153-.314-1.6.088a.58.58 0 00-.168.362c-.022.361.02.727-.014 1.086-.033.362.145.555.43.682.174.077.367.112.55.166zM23.695 2.246h1.114v2.437c.038.009.058.02.064.014.81-.764 2.563-.445 3.174.918.617 1.378-.052 2.96-1.428 3.346-.633.177-1.241.14-1.798-.374.039.336-.137.362-.356.353-.251-.01-.503-.003-.77-.003v-6.69zm1.125 4.43h-.002c0 .173.018.349-.004.519-.034.266.099.422.296.556.52.35 1.334.239 1.733-.241.4-.48.373-1.29-.056-1.746-.44-.468-1.244-.518-1.76-.115-.146.114-.228.24-.211.438.017.195.004.392.004.588zM16.841 4.654c-.022-.194.11-.252.318-.244.266.01.534.003.818.003v4.519c-.325 0-.651.016-.974-.012-.076-.006-.14-.159-.224-.264-.39.367-.897.446-1.442.37-1.062-.151-1.828-1.007-1.928-2.151-.134-1.517 1.069-2.739 2.54-2.548.303.04.59.213.893.327zm.005 2.006h.002c0-.227.007-.453-.004-.68a.374.374 0 00-.085-.217c-.446-.494-1.286-.52-1.807-.061-.49.43-.544 1.285-.116 1.808.405.496 1.261.593 1.77.21.169-.127.267-.269.244-.494-.018-.187-.004-.377-.004-.566zM28.734 4.413c.32 0 .597-.02.869.012.099.011.183.153.291.252.453-.385 1.037-.458 1.653-.312.724.171 1.211.698 1.24 1.445.04 1.03.01 2.064.01 3.113H31.69c-.006-.092-.016-.18-.017-.268-.001-.733 0-1.465-.002-2.198 0-.083 0-.166-.003-.25-.024-.481-.184-.732-.525-.825-.424-.115-1.024.06-1.222.371-.04.062-.042.157-.042.236-.003.891-.002 1.783-.003 2.674v.274h-1.025c-.161-.002-.115-.13-.116-.217-.003-1.027-.002-2.055-.002-3.082V4.413zM21.751 4.682c.34-.297.78-.448 1.281-.36.066.011.169.09.172.142.016.307.008.615.008.93-.18-.017-.338-.06-.487-.04a3.241 3.241 0 00-.731.174c-.228.088-.337.264-.329.548.023.876.009 1.752.01 2.628v.217h-1.126V4.413c.326 0 .64-.016.95.012.082.007.152.15.252.257zM18.703 4.411h1.113v4.507h-1.113V4.41zM19.248 3.788a.766.766 0 01-.752-.79.776.776 0 01.79-.759c.427.01.758.364.746.797a.752.752 0 01-.784.752z"
  }))), mobile_airbnb_defs || (mobile_airbnb_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "airbnb_svg__clip0_13385_3109"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h38v12H0z"
  })))));
}
/* harmony default export */ var mobile_airbnb = (airbnb_SvgAirbnb);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/bain.svg
var mobile_bain_g, mobile_bain_defs;
function mobile_bain_extends() { mobile_bain_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_bain_extends.apply(this, arguments); }

function bain_SvgBain(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_bain_extends({
    width: 43,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_bain_g || (mobile_bain_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#bain_svg__clip0_13385_3135)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M38.274.346c2.546.644 4.904 3.484 4.715 7.05-.207 3.897-3.46 7.053-7.366 6.515-3.665-.505-6.246-4.153-5.582-8.149.67-4.041 4.244-6.274 7.44-5.662-.176.245-.34.485-.52.712-.034.044-.13.047-.197.045-.74-.02-1.469.047-2.163.333-2.036.837-3.266 2.406-3.584 4.72-.413 3.008 1.577 5.926 4.375 6.49 3.06.617 5.917-1.466 6.5-4.74.467-2.624-.916-5.303-3.27-6.325-.105-.046-.163-.102-.186-.222-.047-.253-.105-.504-.162-.767zM20.08.888l4.89 4.82V1c.446 0 .868-.002 1.29.005.032 0 .075.06.093.1.016.038.004.089.004.133v7.935l-4.962-4.893v4.693H20.08V.888zM3.89 4.734c.141.062.258.104.368.164.659.355 1.023.937 1.052 1.717.028.746-.238 1.37-.84 1.794-.44.309-.935.467-1.449.49-.892.038-1.787.026-2.68.035-.01 0-.022-.008-.048-.02V1.033c.01-.009.02-.023.029-.023.922.003 1.848-.073 2.763.1.452.085.877.249 1.221.589.814.804.691 2.274-.24 2.918l-.176.118zM1.7 7.724c.35 0 .69.016 1.026-.006.187-.012.377-.069.554-.138.382-.151.57-.459.574-.897.005-.455-.19-.789-.565-.95-.514-.223-1.05-.143-1.588-.154v2.146zm0-3.362c.426.013.84.034 1.242-.117.36-.137.54-.423.561-.823.023-.433-.07-.816-.473-1.023-.421-.216-.872-.202-1.33-.183v2.147zM9.971.823l3.61 8.092c-.055.01-.092.023-.13.023-.423.001-.847-.003-1.27.003-.106.002-.157-.037-.198-.14-.184-.47-.38-.935-.563-1.405-.048-.122-.105-.173-.236-.172-.84.007-1.68.007-2.521 0-.123 0-.179.048-.226.16-.196.472-.404.937-.6 1.409-.045.111-.102.15-.213.148-.41-.007-.821-.003-1.271-.003L9.97.823zm-.942 5.15h1.8l-.858-2.292-.942 2.293z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M37.576 1.686l1.194 5.66-4.478-1.095 3.284-4.565zM16.824 1v.237c0 2.487-.002 4.974.004 7.461 0 .19-.038.254-.225.246-.386-.018-.773-.006-1.177-.006-.005-.083-.013-.15-.013-.217-.001-2.5 0-5-.004-7.5 0-.171.038-.231.207-.225.392.014.785.004 1.208.004zM13.55 12.291l-.436.863-.43.846-.852-1.649-.041-.001-.318 1.57h-.518l.7-3.061L12.7 12.88l1.014-2.022.732 3.042h-.551l-.344-1.61zM8.899 13.981c-.78.035-1.453-.639-1.48-1.48-.031-.924.59-1.638 1.458-1.676.793-.035 1.447.612 1.486 1.47.042.926-.584 1.647-1.464 1.686zm-.014-.505c.543-.001.96-.453.956-1.036-.004-.671-.376-1.116-.932-1.115-.53.001-.94.485-.936 1.107.003.62.375 1.046.912 1.045zM2.42 12.536l-.446.72.538.668c-.326-.014-.649.13-.817-.269-.645.453-1.213.449-1.532 0-.302-.422-.184-.859.355-1.358-.079-.18-.178-.35-.228-.534-.105-.385.062-.713.41-.855.25-.102.503-.1.75.007a.667.667 0 01.28 1.008c-.117.17-.285.3-.451.47l.423.519c.124-.384.364-.49.72-.377H2.42zm-1.598.086c-.229.15-.338.363-.3.57.036.19.147.299.322.335a.483.483 0 00.52-.24c-.118-.147-.237-.296-.358-.444l-.184-.221zm.248-1.384a.33.33 0 00-.324.349c.006.161.165.425.257.423.137-.003.38-.294.38-.458a.309.309 0 00-.312-.315zM20.902 10.879l1.839 1.808v-1.762h.507v3.058l-1.844-1.831v1.753h-.502v-3.026zM6.795 11.441l-.384.333c-.218-.288-.482-.483-.84-.444a.906.906 0 00-.64.379c-.347.463-.27 1.225.157 1.586.421.356.938.255 1.328-.272l.376.333c-.23.476-.87.732-1.474.599-.631-.14-1.085-.714-1.125-1.425-.04-.729.357-1.38.98-1.61.591-.216 1.3.008 1.622.521zM15.361 10.875c.42.038.816.038 1.197.119.423.09.643.441.64.888-.005.424-.23.738-.64.852-.2.056-.41.07-.649.11v.803c0 .27 0 .271-.247.269-.348-.004-.299.05-.3-.327-.002-.816 0-1.631 0-2.447v-.267zm.596.473c-.023.026-.038.034-.039.044-.004.204-.008.408-.008.611-.002.373.016.388.359.318.029-.006.057-.016.085-.027a.44.44 0 00.31-.458c-.006-.228-.117-.383-.332-.437-.126-.031-.257-.036-.374-.051zM20.19 13.915c-.193 0-.352.007-.51-.004-.04-.003-.091-.053-.113-.095a2.182 2.182 0 01-.15-.368c-.042-.15-.125-.186-.263-.179-.25.012-.5.008-.75.001-.103-.002-.173.02-.202.135-.01.042-.034.08-.052.12-.19.445-.198.45-.694.367l1.361-3.055c.462 1.035.91 2.036 1.374 3.078zm-1.724-1.138h.671l-.32-.854-.35.854zM24.938 13.904c0-.354.009-.697-.004-1.04a.856.856 0 00-.1-.37c-.266-.475-.547-.94-.823-1.41-.028-.047-.053-.096-.095-.174.193 0 .363-.01.53.006.05.005.106.071.137.124.202.345.398.693.614 1.072.168-.282.351-.527.47-.803.152-.352.384-.465.72-.4.021.005.044.006.092.012-.195.332-.359.666-.572.959a2.331 2.331 0 00-.451 1.666c.035.37.006.374-.343.37-.052-.002-.105-.008-.175-.013z"
  }))), mobile_bain_defs || (mobile_bain_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "bain_svg__clip0_13385_3135"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v14H0z"
  })))));
}
/* harmony default export */ var mobile_bain = (bain_SvgBain);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/doctolib.svg
var mobile_doctolib_g, mobile_doctolib_defs;
function mobile_doctolib_extends() { mobile_doctolib_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_doctolib_extends.apply(this, arguments); }

function doctolib_SvgDoctolib(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_doctolib_extends({
    width: 43,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_doctolib_g || (mobile_doctolib_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#doctolib_svg__clip0_13385_3153)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M32.523.926c-.188 1.071-.37 2.129-.56 3.185-.196 1.108-.401 2.215-.598 3.323-.095.53.08.845.499.932.488.101.942.012 1.34-.266.392-.272.695-.6.809-1.092.163-.703.393-1.393.608-2.085.158-.51.493-.714 1.044-.675.149.01.199.053.172.203-.173.963-.34 1.928-.507 2.893-.01.057-.016.116-.026.173-.044.264-.094.543.168.726.284.199.619.22.93.07.388-.186.68-.453.791-.897.575-2.29 1.167-4.578 1.756-6.865.105-.406.48-.611.943-.496l-.711 4.514c.328-.082.64-.188.962-.238 2.184-.336 2.964 1.226 2.846 2.65-.116 1.406-1.02 2.365-2.445 2.703-.696.166-1.377.2-2.056-.05a2.218 2.218 0 01-1.025-.784c-.084.086-.157.165-.235.24-.42.4-.887.72-1.503.735-.712.018-1.25-.295-1.645-.854l-.075-.109c-.004-.005-.011-.009-.021-.016-.258.184-.506.382-.775.55-.655.41-1.362.5-2.114.294-.859-.235-1.398-1.009-1.217-1.847.208-.963.456-1.92.71-2.873.316-1.18.655-2.354.986-3.53.118-.42.478-.621.95-.514h-.001zm6.064 6.305c-.005.832.615 1.36 1.462 1.245 1.01-.137 1.667-.764 1.842-1.757.172-.971-.68-1.733-1.671-1.496-.932.223-1.627 1.078-1.633 2.008zM24.366 9.062c-.407.343-.83.638-1.366.726-1.259.205-2.74-.595-2.413-2.26.254-1.288.646-2.55.976-3.824l.059-.239c-.198 0-.376.003-.553 0-.588-.007-.982-.16-.766-1.075.427 0 .866-.016 1.302.006.258.013.368-.056.427-.31.123-.518.288-1.027.442-1.539.122-.404.485-.6.953-.497a6904.4 6904.4 0 01-.414 2.322c.097.007.183.015.27.018.955.03 1.91.057 2.866.088.225.008.273.086.191.293-.082.206-.252.308-.468.332-.686.077-1.372.151-2.058.22-.271.027-.544.041-.817.056-.124.006-.185.055-.207.178-.25 1.329-.513 2.655-.75 3.985-.103.574.288.953.88.84.277-.052.536-.218.786-.36.058-.032.074-.176.066-.265-.103-1.151.293-2.116 1.241-2.813.895-.657 1.925-.858 3.01-.494.78.26 1.153.88 1.308 1.617.412 1.962-1.026 3.663-3.103 3.693-.653.009-1.243-.21-1.861-.697zm.679-2.071c0 .977.792 1.562 1.778 1.31.839-.213 1.471-1.037 1.476-1.921.004-.815-.69-1.405-1.525-1.296-.974.126-1.729.958-1.73 1.907zM2.138.913c-.5.027-1 .056-1.5.08a.607.607 0 01-.595-.33C-.027.538-.023.46.147.434 1.397.241 2.644.002 3.917 0 5.02-.002 6.093.186 7.099.64c1.394.632 2.123 1.703 2.115 3.181-.008 1.549-.484 2.966-1.516 4.177-.934 1.097-2.17 1.686-3.61 1.898-.982.144-1.968.131-2.951.008L1.09 9.9c-.624-.09-.756-.273-.595-.854.595-2.143 1.192-4.285 1.792-6.427.116-.415.377-.592.791-.57.138.009.184.046.157.188-.184.954-.359 1.91-.538 2.866-.183.976-.372 1.953-.552 2.93-.08.432.027.546.478.553.827.013 1.638-.076 2.4-.407 1.357-.59 2.128-1.648 2.53-2.989.186-.625.272-1.262.123-1.905-.218-.943-.896-1.497-1.78-1.85-.99-.399-2.041-.483-3.099-.521-.22-.008-.44-.001-.66-.001zM14.978 7.672c-.291.051-.46.18-.584.436-.72 1.483-2.748 2.114-4.228 1.31-.665-.362-1.024-.963-1.09-1.684-.21-2.275 1.851-3.829 3.992-3.364.872.19 1.311.814 1.542 1.6.034.117.054.238.097.426.179-.188.331-.332.465-.49.252-.301.468-.634.746-.91.778-.77 2.097-.86 3.01-.237.117.08.139.15.065.271-.194.32-.285.361-.64.25-.714-.223-1.433.043-1.817.714-.425.741-.392 1.504.016 2.242.247.446.789.63 1.366.512a2.484 2.484 0 001.284-.706c.07-.07.165-.146.257-.159.277-.038.427.157.326.405-.365.896-1.053 1.424-2.032 1.552-.924.121-1.707-.177-2.29-.897-.296-.367-.424-.802-.485-1.27zm-4.616-.7c-.01.793.445 1.32 1.266 1.372.293.02.625-.064.89-.194.74-.36 1.056-1.013 1.093-1.773.04-.81-.688-1.402-1.522-1.293-.964.125-1.715.946-1.727 1.887z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M36.403 2.465c-.002.443-.343.77-.809.772-.355.001-.598-.232-.598-.577 0-.503.324-.83.822-.829.367 0 .587.24.585.634z"
  }))), mobile_doctolib_defs || (mobile_doctolib_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "doctolib_svg__clip0_13385_3153"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v10H0z"
  })))));
}
/* harmony default export */ var mobile_doctolib = (doctolib_SvgDoctolib);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/ey.svg
var mobile_ey_g, mobile_ey_defs;
function mobile_ey_extends() { mobile_ey_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_ey_extends.apply(this, arguments); }

function ey_SvgEy(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_ey_extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_ey_g || (mobile_ey_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#ey_svg__clip0_13385_3053)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M.5 10.119c1.962 0 3.873-.003 5.784.007.134 0 .326.07.39.167.43.653.833 1.322 1.304 2.082h-4.23v1.61h3.779v2.1h-3.78v1.7h4.101c.808 0 1.212.376 1.212 1.128V20H.5v-9.881zM7.682 10.065c1.09 0 2.152-.015 3.212.017.15.004.337.218.429.375.534.916 1.045 1.844 1.605 2.841.553-.983 1.082-1.883 1.565-2.804.173-.33.379-.453.77-.442.962.024 1.925.007 3 .007-.149.26-.24.434-.345.6-1.03 1.652-2.073 3.295-3.082 4.957a2.075 2.075 0 00-.286.977c-.034 1.097-.013 2.196-.013 3.325H11.32c0-.497-.053-1.009.01-1.508.207-1.627-.273-3.04-1.261-4.387-.875-1.194-1.583-2.496-2.362-3.75-.017-.029-.01-.07-.025-.208zM.5 7.065L21.5 0v3.643L.5 7.065z"
  }))), mobile_ey_defs || (mobile_ey_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "ey_svg__clip0_13385_3053"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h21v20H0z"
  })))));
}
/* harmony default export */ var mobile_ey = (ey_SvgEy);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/getyourguide.svg
var mobile_getyourguide_g, mobile_getyourguide_defs;
function mobile_getyourguide_extends() { mobile_getyourguide_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_getyourguide_extends.apply(this, arguments); }

function getyourguide_SvgGetyourguide(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_getyourguide_extends({
    width: 21,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_getyourguide_g || (mobile_getyourguide_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#getyourguide_svg__clip0_13385_3131)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M2.371 0C1.037 0 .035.87.035 2.134v.654c0 1.247.943 2.167 2.114 2.167a2.122 2.122 0 001.693-.818v.717h.966V2.23H2.196v.891h1.423c-.117.492-.603.87-1.224.87-.62 0-1.283-.491-1.283-1.202v-.655c0-.672.521-1.168 1.253-1.168.568 0 1.078.299 1.248.74l1.025-.35C4.357.524 3.432 0 2.37 0zm3.227.096v4.758h3.163v-.96H6.705v-.948H8.54v-.954H6.705v-.937h2.02V.096H5.6zm3.637 0v.96h3.748v-.96H9.235zm1.318 1.337v.887h1.107v-.887h-1.107zm0 1.265v.886h1.107v-.886h-1.107zm0 1.27v.885h1.107v-.885h-1.107zM7.262 5.525v.999c.808 0 1.452.643 1.452 1.473 0 .83-.644 1.473-1.452 1.473-.809 0-1.453-.638-1.453-1.473H4.673c0 1.388 1.148 2.478 2.589 2.478 1.44 0 2.588-1.09 2.588-2.478 0-1.388-1.148-2.472-2.588-2.472zM0 5.621l1.862 2.963v1.795H2.97V8.573l1.856-2.951H3.578L2.407 7.569 1.253 5.622H0zm10.53 0v2.907c0 1.117.866 1.947 2.06 1.947 1.196 0 2.062-.83 2.062-1.947V5.62H13.55v2.923c0 .548-.41.954-.96.954-.551 0-.961-.406-.961-.954V5.621h-1.101zm5.54 0l-.627.632.574.581-.563.593.568.582-.562.592.574.587-.568.587.609.609h1.153l-.62-.615.568-.593-.574-.581.568-.593-.574-.582.562-.592-.574-.581.632-.627H16.07v.001zm1.44 0v.965h.603c.306.03.538.277.538.573a.584.584 0 01-.538.573h-.603v.914l1.2 1.733h1.347L18.71 8.562c.659-.186 1.113-.766 1.119-1.428 0-.863-.738-1.512-1.675-1.512h-.644zM6.427 5.65a.565.565 0 00-.577.548v.011a.564.564 0 00.577.548.564.564 0 00.571-.553.564.564 0 00-.57-.553zM5.4 6.643a.575.575 0 00-.58.57v.01a.542.542 0 00.173.39c.108.103.255.16.407.158h.012a.575.575 0 00.58-.57.576.576 0 00-.592-.559zm-3.028 4.402c-1.334 0-2.336.869-2.336 2.133v.655C.035 15.08.978 16 2.149 16a2.122 2.122 0 001.693-.818v.716h.966v-2.624H2.196v.892h1.423c-.117.491-.603.87-1.224.87-.62 0-1.283-.492-1.283-1.203v-.654c0-.672.521-1.169 1.253-1.169.568 0 1.078.3 1.248.74l1.025-.35c-.282-.83-1.207-1.354-2.267-1.354v-.001zm8.194.09v.446h.005v.017c0 .44.276.677.44.818.164.142.117.108.117.147 0 .04 0 .051-.117.153-.118.101-.416.361-.434.767v.074c.017.406.276.632.434.767.158.135.117.107.117.147 0 .04 0 .05-.117.152-.118.102-.44.378-.44.818v.011h-.005v.446h1.112v-.332a.39.39 0 01.1-.26l.018-.017c.164-.141.439-.378.439-.818 0-.44-.275-.672-.44-.819-.163-.147-.117-.101-.117-.135s.018-.045.123-.135h-.005c.164-.141.439-.378.439-.819 0-.44-.275-.671-.44-.812l-.017-.023a.366.366 0 01-.1-.254v-.338h-1.112zm2.365 0v4.763h1.629c1.528 0 2.612-1.01 2.612-2.375 0-1.366-1.084-2.388-2.612-2.388H12.93zm-7.355.012v2.9c0 1.123.873 1.953 2.067 1.953 1.195 0 2.062-.83 2.062-1.953v-2.9h-1.1v2.923c0 .547-.41.948-.961.948-.55 0-.96-.4-.96-.948v-2.923H5.574zm12.257 0v4.751H21v-.953h-2.055v-.954h1.826v-.948h-1.826V12.1h2.02v-.953h-3.133zm-3.789.947h.603c.826 0 1.388.616 1.388 1.428 0 .813-.562 1.422-1.388 1.422h-.603v-2.85z",
    fill: "#C3C6C5"
  }))), mobile_getyourguide_defs || (mobile_getyourguide_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "getyourguide_svg__clip0_13385_3131"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v16H0z"
  })))));
}
/* harmony default export */ var mobile_getyourguide = (getyourguide_SvgGetyourguide);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/jll.svg
var mobile_jll_g, mobile_jll_defs;
function mobile_jll_extends() { mobile_jll_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_jll_extends.apply(this, arguments); }

function jll_SvgJll(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_jll_extends({
    width: 37,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_jll_g || (mobile_jll_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#jll_svg__clip0_13385_3122)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.99 0C8.6.974 7.75 2.326 7.189 3.858c-.662 1.805-.785 3.674-.591 5.57.083.819.256 1.62.515 2.405.021.066.035.152.01.213-.189.472-.388.94-.584 1.408l-.078.002c-.163-.335-.341-.663-.483-1.006-.69-1.664-.905-3.402-.817-5.182.067-1.376.344-2.71.915-3.976.163-.362.352-.715.559-1.054.093-.154.094-.254-.007-.397-.232-.328-.225-.334.038-.648.096-.116.198-.227.314-.358.155.13.298.25.438.37L8.158.58l-.7-.565c-.556.35-1.009.78-1.4 1.272-1.18 1.486-1.787 3.187-1.996 5.034-.202 1.799-.115 3.58.42 5.324A8.81 8.81 0 005.78 14.28c.088.12.086.202-.01.308-.151.168-.293.344-.465.548-.192-.183-.38-.344-.546-.525-.945-1.03-1.502-2.255-1.813-3.58-.62-2.643-.52-5.248.574-7.775.442-1.02 1.072-1.914 1.99-2.596.017-.013.028-.034.06-.072-.191-.16-.385-.318-.572-.482-.101-.089-.18-.069-.282.005a6.296 6.296 0 00-1.311 1.286C2.426 2.671 1.848 4.106 1.59 5.662c-.336 2.039-.277 4.065.35 6.052.454 1.444 1.174 2.75 2.34 3.776.68.599.485.602 1.177-.007 1.228-1.079 1.972-2.458 2.4-3.99.679-2.435.647-4.87-.087-7.296a.698.698 0 01.007-.423c.163-.431.358-.852.54-1.276l.092-.006c.214.483.458.956.635 1.451.629 1.765.779 3.584.589 5.436-.149 1.443-.525 2.824-1.276 4.082-.222.371-.245.636.063.928.01.01.016.025.04.066l-.566.686-.463-.385-.734.626.662.551-.023.067c-.365-.094-.73-.19-1.096-.28-.067-.017-.15-.039-.208-.016-1.319.534-2.447.143-3.452-.705-.962-.813-1.515-1.889-1.928-3.037-.36-1-.55-2.033-.61-3.09C.037 8.8.013 8.727 0 8.655V7.309c.048-.406.085-.813.145-1.217.219-1.47.664-2.864 1.527-4.105.597-.859 1.341-1.555 2.4-1.86C4.24.08 4.41.043 4.58 0h.51c.328.095.657.192.987.285.033.01.075.01.108.001.329-.094.657-.19.985-.286h.463l1.03.284a.172.172 0 00.089.001C9.087.192 9.423.095 9.76 0h.23z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.268 0c.17.042.342.079.509.128 1.058.308 1.807.999 2.408 1.86.85 1.216 1.3 2.58 1.519 4.022a12.723 12.723 0 01-.002 3.952c-.267 1.668-.798 3.238-1.938 4.557-.64.742-1.425 1.273-2.442 1.416-.469.065-.921-.021-1.356-.182a.68.68 0 00-.502-.007c-.308.107-.634.166-.969.249.007-.058.003-.079.011-.084 1.51-1.117 2.376-2.64 2.9-4.368.458-1.515.546-3.069.436-4.637-.103-1.453-.439-2.848-1.122-4.15-.22-.419-.48-.815-.738-1.246l.556-.663c.625.503 1.087 1.104 1.461 1.772.617 1.102.98 2.286 1.145 3.524.248 1.85.168 3.682-.4 5.476-.365 1.153-.878 2.233-1.75 3.119-.217.22-.462.415-.718.643.208.168.413.346.635.502.046.032.173.004.231-.038.751-.546 1.33-1.241 1.81-2.016.776-1.248 1.203-2.61 1.384-4.049.222-1.767.151-3.52-.34-5.242-.42-1.478-1.129-2.807-2.243-3.91-.225-.224-.476-.42-.716-.628h.231zM23.046 3.197h4.193l.02.37-.415.064c-.452.066-.641.268-.668.715-.003.052-.007.104-.007.157.001 2.18-.006 4.363.008 6.544.005.71.158.875.88.947.41.04.834.023 1.242-.038.507-.076.867-.393 1.123-.821.179-.298.211-.308.598-.23-.007.043-.008.088-.022.128-.187.528-.37 1.058-.57 1.582-.024.067-.131.149-.201.149-2.011.007-4.023.006-6.034.005-.037 0-.074-.013-.122-.022v-.352c.088-.019.175-.04.264-.056.442-.08.637-.29.669-.726.008-.12.009-.24.009-.359-.001-2.264 0-4.527-.005-6.792-.002-.57-.21-.795-.793-.875-.291-.04-.1-.24-.17-.39zM30.02 12.77v-.26c0-.037.005-.073.006-.106.867-.225.946-.29.952-1.137.014-2.22.003-4.44.002-6.659 0-.09-.011-.179-.02-.268-.054-.483-.273-.696-.777-.753l-.148-.017V3.2h4.17v.364c-.198.036-.395.067-.588.109a.548.548 0 00-.453.478 2.95 2.95 0 00-.046.49c-.004 2.04-.005 4.08-.001 6.12 0 .193.02.388.045.58.051.384.195.577.585.612a7.577 7.577 0 001.515-.002c.499-.058.854-.383 1.108-.803.189-.313.204-.317.63-.244-.21.592-.414 1.182-.636 1.766-.02.055-.157.096-.24.097-1.62.005-3.238.004-4.857.004H30.02zM16.159 10.903h.42c.179.268.31.537.508.743.385.398.881.506 1.42.357.515-.143.707-.547.777-1.013.044-.287.054-.58.055-.87.004-1.778 0-3.556 0-5.335 0-.09-.001-.18-.003-.269-.011-.627-.169-.807-.797-.917-.21-.036-.3-.169-.27-.397h4.154v.347c-.022.013-.034.025-.047.027-.658.08-.836.25-.898.888-.022.222-.016.448-.016.672-.002 1.725.006 3.451-.007 5.177a4.086 4.086 0 01-.14 1.015c-.263.982-1.051 1.613-2.096 1.665-.441.022-.899.018-1.329-.068-1.002-.202-1.501-.888-1.698-1.819-.013-.058-.02-.117-.034-.203z"
  }))), mobile_jll_defs || (mobile_jll_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "jll_svg__clip0_13385_3122"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h37v16H0z"
  })))));
}
/* harmony default export */ var mobile_jll = (jll_SvgJll);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/meta.svg
var mobile_meta_g, mobile_meta_defs;
function mobile_meta_extends() { mobile_meta_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mobile_meta_extends.apply(this, arguments); }

function meta_SvgMeta(props) {
  return /*#__PURE__*/react.createElement("svg", mobile_meta_extends({
    width: 49,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), mobile_meta_g || (mobile_meta_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#meta_svg__clip0_13385_3043)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7.816 4.788c-.51.9-.925 1.748-1.449 2.517-.523.768-1.068 1.568-1.763 2.153-1.281 1.078-3.174.467-3.767-1.127C.284 6.845.49 5.354.907 3.88c.354-1.246.93-2.367 1.958-3.176 1.169-.922 2.57-.947 3.742-.038.491.38.911.857 1.286 1.217L9.186.758c1.075-.932 2.33-1.012 3.472-.164.395.294.77.662 1.043 1.073 1.226 1.845 1.648 3.894 1.257 6.087-.178 1-.69 1.808-1.716 2.1-1.012.287-1.943.044-2.617-.766-.652-.784-1.196-1.664-1.76-2.522-.356-.54-.661-1.117-1.049-1.78v.002zm5.864 1.486l-.031-.004c-.01-.181-.01-.364-.03-.545-.162-1.451-.488-2.835-1.588-3.88-.722-.686-1.566-.685-2.274.018-.278.277-.504.608-.767.902-.212.237-.217.437-.04.718.606.961 1.173 1.949 1.772 2.916.303.49.621.974.97 1.43.295.388.717.536 1.19.412.434-.114.614-.467.676-.888.053-.358.082-.72.12-1.08h.002zm-11.575.053c.049.377.06.764.155 1.129.215.815 1.008 1.082 1.672.577.183-.14.362-.303.49-.493.664-.989 1.318-1.984 1.96-2.986.717-1.118.694-1.251-.286-2.187-1.07-1.022-2.144-.884-2.927.383-.674 1.09-.959 2.298-1.064 3.577zM23.043 6c.473-.874.902-1.664 1.329-2.456.499-.924 1.009-1.841 1.486-2.777.17-.332.364-.468.741-.464 1.34.013 1.34-.003 1.34 1.37 0 2.494-.012 4.989.009 7.483.004.485-.104.675-.615.65-1.078-.054-.936.13-.94-.957-.007-1.964-.003-3.927-.003-6.068-.17.255-.26.37-.33.496-.711 1.302-1.442 2.594-2.115 3.917-.25.493-.625.37-.997.39-.359.02-.664.02-.88-.404-.643-1.257-1.337-2.487-2.012-3.727-.099-.182-.203-.362-.404-.51-.008.172-.023.343-.023.516-.001 1.912-.016 3.824.01 5.736.006.48-.125.632-.598.61-1.086-.048-.925.132-.928-.961-.008-2.659.004-5.317-.01-7.975-.003-.416.108-.52.527-.577 1.004-.132 1.564.247 1.993 1.196.61 1.351 1.383 2.625 2.087 3.931.092.17.191.336.333.584v-.002zM46.926 3.412c.102-.267.157-.632.263-.648.394-.06.806-.018 1.208.02.042.003.096.217.097.334.005 2.094.001 4.188.007 6.282 0 .268-.08.418-.365.394a2.136 2.136 0 00-.32 0c-.499.035-.984.057-.777-.74-.11.025-.173.018-.199.047-1.278 1.428-3.97 1.14-4.875-1.198-.632-1.633-.215-3.649.986-4.656 1.122-.941 2.696-.923 3.814.042.05.044.107.081.16.122zm.123 2.848c-.049-.411-.016-.855-.163-1.224-.33-.83-1.04-1.09-1.864-1.07-.758.018-1.443.473-1.633 1.245-.139.565-.192 1.2-.093 1.77.23 1.32 1.356 1.9 2.588 1.427.884-.34 1.12-.792 1.164-2.148zM30.81 6.843c.07 1.78 1.756 2.207 4.007 1.036l.753.933c-.795.821-1.753 1.107-2.805 1.144-2.127.076-3.627-1.538-3.565-3.829.062-2.263 1.634-3.747 3.76-3.548 1.403.131 2.47 1.233 2.708 2.796.149.979-.25 1.468-1.196 1.468H30.81zm3.4-1.196c-.014-1.103-.703-1.783-1.724-1.746-.95.034-1.689.804-1.658 1.746h3.383zM37.486.667c.451 0 .838-.025 1.218.018.098.011.242.235.248.367.03.525.012 1.05.012 1.665.553 0 1.08.034 1.6-.01.564-.047.477.329.477.667s.086.713-.475.665c-.507-.042-1.02-.009-1.509-.009 0 1.306-.024 2.552.013 3.795.015.488.394.712.847.742.348.022.698.004 1.042.004.024.041.057.07.059.101.04 1.291.204 1.193-1.124 1.27-1.456.085-2.326-.79-2.377-2.306-.033-.98-.014-1.963-.018-2.945v-.663c-.372 0-.686-.008-1 .002-.257.01-.405-.074-.386-.369.012-.199-.042-.414.017-.595.045-.14.207-.313.338-.334.31-.049.632-.016 1.017-.016V.667z"
  }))), mobile_meta_defs || (mobile_meta_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "meta_svg__clip0_13385_3043"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h48v10H0z"
  })))));
}
/* harmony default export */ var mobile_meta = (meta_SvgMeta);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/n26.svg
var n26_g, n26_defs;
function n26_extends() { n26_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return n26_extends.apply(this, arguments); }

function SvgN26(props) {
  return /*#__PURE__*/react.createElement("svg", n26_extends({
    width: 30,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), n26_g || (n26_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#n26_svg__clip0_13385_3061)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M.5 16.904h7.81v1.093H.61c-.037 0-.073 0-.11.002v-1.095zM8.317 0v1.085c-.036.003-.066.005-.095.005-2.535 0-5.07 0-7.605.003-.08 0-.098-.028-.097-.118C.523.65.52.325.518 0h7.8-.001zM1.748 5.637v9.627H.518V2.688c.022-.002.046-.006.07-.006l.917-.001c.05 0 .08.019.11.068 1.568 2.736 3.138 5.47 4.707 8.204l.69 1.2.043.068V2.69h1.24v12.575c-.024.002-.048.006-.071.006-.292 0-.584-.002-.876.002-.054 0-.084-.022-.114-.074-.917-1.604-1.836-3.206-2.754-4.81L1.795 5.708c-.01-.019-.022-.035-.045-.07h-.002zM29.216 4c-.023.036-.038.061-.054.084L28.41 5.13c-.121-.127-.242-.244-.355-.371-.42-.476-.918-.773-1.495-.851-1.06-.143-1.877.326-2.443 1.398-.303.575-.476 1.208-.584 1.868-.052.322-.085.647-.13.992.036-.025.054-.036.07-.051.623-.554 1.321-.9 2.095-.998.976-.125 1.885.116 2.688.806.627.54.994 1.286 1.148 2.174.17.965.124 1.92-.198 2.838-.473 1.354-1.308 2.216-2.535 2.485-1.06.233-2.042-.002-2.89-.83-.492-.48-.839-1.09-1.09-1.779a8.793 8.793 0 01-.46-2.034 14.374 14.374 0 01-.077-2.202c.041-1.118.195-2.212.57-3.248.311-.863.752-1.612 1.41-2.158a3.068 3.068 0 011.64-.704c1.008-.114 1.932.152 2.754.86.24.207.457.447.687.673V4zm-.96 7.049c-.016-.136-.03-.395-.079-.646-.144-.756-.494-1.331-1.112-1.634a2.31 2.31 0 00-1.698-.153c-.776.223-1.391.755-1.915 1.45a.171.171 0 00-.026.106c.026.249.048.5.088.746.1.625.262 1.227.555 1.766.504.93 1.188 1.477 2.164 1.355.526-.066.982-.316 1.346-.774.465-.587.662-1.3.677-2.215v-.001zM13.427 13.818h5.543c.003.034.007.06.007.085 0 .428-.001.855.002 1.284 0 .077-.017.102-.084.102-2.226-.002-4.453-.001-6.68-.002-.019 0-.039-.003-.068-.005-.001-.036-.004-.071-.004-.106.005-.405 0-.81.018-1.213.05-1.01.342-1.901.947-2.639.446-.543.952-1 1.484-1.415.56-.439 1.135-.856 1.695-1.296.396-.31.764-.664 1.06-1.11.3-.453.425-.965.394-1.54-.026-.485-.135-.931-.402-1.31a1.664 1.664 0 00-1.036-.684c-.713-.16-1.377-.012-1.977.482-.379.313-.659.724-.849 1.222-.066.175-.137.347-.208.53l-1.116-.607c.5-1.59 1.398-2.662 2.814-3.043a3.147 3.147 0 012.367.267c.872.465 1.394 1.275 1.594 2.372.13.714.121 1.428-.08 2.127-.175.604-.486 1.1-.869 1.538-.5.575-1.079 1.023-1.672 1.45-.606.438-1.208.881-1.76 1.41a5.78 5.78 0 00-.59.652c-.333.434-.473.845-.53 1.448v.001z"
  }))), n26_defs || (n26_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "n26_svg__clip0_13385_3061"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h29v18H0z"
  })))));
}
/* harmony default export */ var n26 = (SvgN26);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/spotify.svg
var spotify_g, spotify_defs;
function spotify_extends() { spotify_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return spotify_extends.apply(this, arguments); }

function SvgSpotify(props) {
  return /*#__PURE__*/react.createElement("svg", spotify_extends({
    width: 40,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), spotify_g || (spotify_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#spotify_svg__clip0_13385_3070)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M.5 5.933c.005-.068.014-.135.016-.203a5.741 5.741 0 01.972-2.99C2.408 1.361 3.69.484 5.328.138A5.904 5.904 0 019.19.595c1.603.77 2.67 2.01 3.201 3.692.2.633.291 1.286.25 1.947-.148 2.313-1.262 4.026-3.326 5.124a5.479 5.479 0 01-2.047.605c-1.849.186-3.47-.334-4.835-1.578A5.743 5.743 0 01.606 7.064C.552 6.76.541 6.45.511 6.144c-.002-.02-.009-.038-.013-.057v-.155l.001.001zm1.892-1.84c0 .375.352.642.72.535.701-.203 1.42-.294 2.146-.321.885-.033 1.764.03 2.633.202.797.16 1.564.403 2.273.808.08.045.178.075.27.08a.555.555 0 00.559-.389.534.534 0 00-.249-.636 9.344 9.344 0 00-.916-.447c-1.288-.522-2.64-.716-4.024-.739a11.541 11.541 0 00-1.533.083c-.503.059-1 .152-1.484.296a.55.55 0 00-.395.528zm3.1 1.155c-.138.006-.346.01-.554.025-.208.015-.417.025-.62.064-.394.075-.786.16-1.176.255a.457.457 0 00-.34.486.48.48 0 00.622.396c.65-.2 1.321-.281 2-.293.465-.008.93.025 1.392.095.934.14 1.821.415 2.635.899a.467.467 0 00.65-.157.454.454 0 00-.173-.638 8.136 8.136 0 00-.642-.34c-1.179-.546-2.427-.78-3.795-.792zm.149 1.969c-.13 0-.26-.004-.391 0-.637.023-1.266.118-1.886.26-.218.049-.35.24-.305.436.047.21.248.333.47.284.563-.127 1.13-.21 1.706-.24.56-.03 1.116 0 1.667.1.69.123 1.336.36 1.937.719a.372.372 0 00.52-.127c.105-.177.05-.391-.137-.505a5.018 5.018 0 00-.293-.167c-1.027-.546-2.132-.769-3.29-.76h.002zM34.643 5.549V8.66c0 .126-.002.13-.131.13h-.826c-.113 0-.123-.01-.123-.125V5.543h-.383c-.128 0-.134-.006-.134-.128v-.679c0-.12.017-.136.142-.136h.368c.009-.156.01-.307.026-.457.044-.408.195-.758.579-.97.174-.096.366-.14.564-.153.308-.021.612.007.91.093.065.019.088.05.088.115-.003.235 0 .47-.001.705 0 .109-.025.12-.131.098-.17-.034-.34-.073-.51-.08-.247-.01-.384.107-.43.346-.018.1-.014.204-.022.316h.106c.476 0 .951.002 1.425-.003.09 0 .133.028.164.11.339.884.683 1.766 1.025 2.648.01.028.023.055.042.098l.622-1.754c.12-.34.242-.677.36-1.018.022-.063.056-.084.12-.082.296.002.591 0 .886 0 .124 0 .145.03.1.145L37.915 8.75c-.113.288-.231.573-.423.822-.222.289-.519.44-.88.466a2.037 2.037 0 01-1.11-.221c-.096-.052-.105-.071-.06-.168l.28-.608c.04-.085.058-.084.148-.053.143.05.29.1.437.124.217.037.37-.071.479-.253.052-.087.064-.16.021-.261-.425-.992-.842-1.985-1.26-2.98-.023-.056-.05-.077-.113-.076-.235.005-.469.001-.704.003-.025 0-.05.003-.086.006v-.002zM20.25 5.1c.172-.13.329-.279.513-.379.522-.281 1.064-.263 1.595-.029.642.284.997.8 1.133 1.466.106.522.076 1.039-.14 1.531-.3.682-.829 1.085-1.576 1.174-.559.067-1.053-.091-1.454-.498l-.071-.063v1.584c0 .121-.012.133-.135.133h-.825c-.104 0-.12-.017-.12-.12V4.727c0-.111.012-.123.125-.123h.834c.108 0 .12.012.12.119 0 .125.002.252.004.378 0 .004.006.008-.003-.004V5.1zm1.083 2.83c.338-.004.623-.11.822-.366.363-.47.392-.99.14-1.51-.343-.706-1.305-.792-1.794-.174-.355.447-.366 1.154-.023 1.61.216.287.507.433.855.44zM16.634 3.198a3.228 3.228 0 011.924.651c.115.087.117.099.035.213l-.438.61c-.063.088-.083.09-.174.025-.315-.225-.651-.405-1.039-.473-.288-.05-.576-.062-.849.074-.248.125-.355.345-.297.613a.41.41 0 00.24.3c.223.097.452.183.685.257.319.102.645.18.962.283.15.048.291.125.429.204.46.263.691.663.7 1.184.01.443-.114.842-.431 1.168a1.784 1.784 0 01-1.011.51c-1.07.177-2.016-.1-2.84-.79-.079-.066-.08-.092-.014-.17.17-.198.339-.398.508-.597.071-.083.091-.085.177-.014.345.288.72.518 1.17.604.288.055.576.073.86-.01.221-.063.4-.18.466-.416a.491.491 0 00-.23-.585c-.226-.14-.483-.198-.736-.27-.35-.099-.701-.193-1.043-.311a1.57 1.57 0 01-.68-.448c-.284-.324-.351-.713-.313-1.124.069-.752.629-1.257 1.357-1.41.19-.041.389-.052.583-.077v-.001zM26.092 4.512c1.074.014 1.96.69 2.19 1.707.277 1.232-.508 2.381-1.728 2.615-.853.163-1.598-.054-2.187-.699-.418-.459-.578-1.011-.527-1.626.077-.92.757-1.736 1.77-1.94.158-.03.32-.04.48-.058l.002.001zm1.164 2.203c0-.23-.053-.443-.162-.643-.386-.703-1.39-.808-1.899-.195-.265.32-.324.694-.256 1.092a1.169 1.169 0 001.68.846c.45-.227.621-.622.637-1.1zM28.921 5.542h-.398c-.109 0-.123-.012-.123-.117v-.704c0-.097.018-.114.118-.115h.399c.002-.035.004-.066.004-.096v-.893c0-.108.013-.122.118-.122.283 0 .567.002.85 0 .084 0 .114.03.113.11-.003.306 0 .613-.002.919 0 .063.017.083.082.082.299-.003.598-.002.895 0 .113 0 .126.012.127.122 0 .234-.002.469.001.703.001.081-.029.112-.112.111-.3-.003-.602 0-.904-.002-.065 0-.09.014-.09.085.003.61 0 1.219.002 1.83 0 .05.005.102.016.152.036.18.167.278.379.284.191.005.373-.032.546-.113.104-.048.146-.022.147.089 0 .223-.002.446.001.67.001.068-.028.103-.085.133a1.704 1.704 0 01-.976.181 1.737 1.737 0 01-.51-.116c-.378-.158-.534-.48-.582-.86a3.182 3.182 0 01-.018-.378c-.002-.615 0-1.23 0-1.846v-.11l.002.001zM31.533 6.696V4.738c0-.121.01-.132.135-.132h.825c.111 0 .125.015.125.125v3.933c0 .116-.01.126-.13.126h-.834c-.11 0-.12-.01-.12-.119V6.696zM31.405 3.43c0-.372.293-.662.671-.662.38 0 .681.296.679.668a.667.667 0 01-.675.662.66.66 0 01-.675-.669v.001z"
  }))), spotify_defs || (spotify_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "spotify_svg__clip0_13385_3070"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h39v12H0z"
  })))));
}
/* harmony default export */ var spotify = (SvgSpotify);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/sumup.svg
var sumup_g, sumup_defs;
function sumup_extends() { sumup_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sumup_extends.apply(this, arguments); }

function SvgSumup(props) {
  return /*#__PURE__*/react.createElement("svg", sumup_extends({
    width: 45,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), sumup_g || (sumup_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#sumup_svg__clip0_13385_3037)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13.375 0H1.485C.948 0 .5.455.5 1v12c0 .544.448.999.985.999h11.89c.537 0 .985-.455.985-1V1c0-.567-.448-.999-.985-.999zM9.188 10.523a3.212 3.212 0 01-4.411.158l-.023-.023c-.067-.068-.09-.205 0-.295l4.3-4.34a.232.232 0 01.29 0c1.12 1.317 1.076 3.272-.156 4.499zm.895-6.932l-4.3 4.34a.232.232 0 01-.29 0c-1.12-1.294-1.075-3.249.134-4.477a3.213 3.213 0 014.412-.158s.023 0 .023.023c.111.068.111.205.022.273V3.59z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.406 6.318c-.604-.25-.985-.408-.985-.773 0-.295.224-.568.739-.568.314 0 .583.137.783.409.135.158.27.25.426.25.313 0 .56-.25.56-.545 0-.114-.023-.227-.09-.296-.337-.523-1.03-.886-1.68-.886-.896 0-1.814.568-1.814 1.66 0 1.09.896 1.477 1.635 1.75.583.226 1.097.43 1.097.909 0 .363-.336.727-.963.727-.201 0-.56-.046-.806-.342-.134-.158-.29-.227-.425-.227-.29 0-.56.25-.56.545a.55.55 0 00.112.319c.336.523 1.097.773 1.68.773.985 0 2.06-.637 2.06-1.795-.023-1.227-.985-1.613-1.769-1.91zM42.62 3.886h-.022a1.92 1.92 0 00-1.926 1.931v6.727c0 .295.246.545.537.545.29 0 .537-.25.537-.545V9.75c.202.181.537.273.85.273h.023c1.076 0 1.882-.932 1.882-2v-2.25c0-1.068-.806-1.886-1.882-1.886h.001zm.851 4.182c0 .591-.38.841-.829.841h-.023c-.47 0-.828-.25-.828-.84v-2.25c0-.455.38-.842.828-.842h.023a.82.82 0 01.83.841v2.25zM32.7 3.886h-.023c-.537 0-1.008.227-1.343.568a1.92 1.92 0 00-1.343-.568h-.023c-1.03 0-1.881.841-1.881 1.91V9.5c.022.295.246.523.537.523.29 0 .515-.227.537-.523V5.795c0-.454.358-.818.806-.818h.023c.448 0 .783.342.806.795V9.5c.027.269.213.523.515.523.302 0 .515-.227.537-.523V5.75c.023-.431.381-.795.806-.795h.023c.448 0 .806.364.806.818v3.728c.023.295.246.523.537.523.291 0 .515-.227.537-.523V5.796A1.874 1.874 0 0032.7 3.887v-.001zm-6.36 0c-.29 0-.515.227-.537.523v3.704a.814.814 0 01-.83.818h-.022a.828.828 0 01-.829-.818V4.386c-.022-.295-.246-.523-.537-.523-.29 0-.515.227-.537.523V8.09c0 1.045.85 1.91 1.903 1.91h.023a1.91 1.91 0 001.903-1.91V4.41a.53.53 0 00-.537-.523zm12.719 0c-.291 0-.516.227-.537.523v3.704a.814.814 0 01-.83.818h-.022a.828.828 0 01-.829-.818V4.386c-.023-.295-.246-.523-.537-.523-.29 0-.515.227-.537.523V8.09c0 1.045.85 1.91 1.903 1.91h.023a1.91 1.91 0 001.903-1.91V4.41c-.023-.295-.246-.523-.537-.523z"
  }))), sumup_defs || (sumup_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "sumup_svg__clip0_13385_3037"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h44v14H0z"
  })))));
}
/* harmony default export */ var sumup = (SvgSumup);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/taxfix.svg
var taxfix_g, taxfix_defs;
function taxfix_extends() { taxfix_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return taxfix_extends.apply(this, arguments); }

function SvgTaxfix(props) {
  return /*#__PURE__*/react.createElement("svg", taxfix_extends({
    width: 39,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), taxfix_g || (taxfix_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#taxfix_svg__clip0_13385_3023)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.505 10c-.306-.052-.623-.072-.917-.16-1.445-.435-2.182-1.43-2.412-2.79-.172-1.013.054-1.957.68-2.804.846-1.145 2.601-1.605 3.82-.988.277.14.505.361.775.56v-.612h2.057v6.549h-2.035v-.838c-.435.75-1.089.997-1.843 1.083h-.127.002zM8.27 6.447l.03.004c0 .108-.007.216 0 .324.055.765.63 1.386 1.347 1.459.817.083 1.476-.329 1.713-1.084a2.186 2.186 0 00-.046-1.48c-.248-.638-.844-.98-1.607-.937-.641.036-1.17.454-1.333 1.075-.056.208-.071.426-.104.639zM32.489 10l-1.392-1.23 2.33-2.173c-.779-.728-1.513-1.413-2.235-2.09L32.564 3.2l2.226 2.097 2.248-2.12 1.347 1.262-2.22 2.08 2.336 2.2L37.087 10h-.064l-2.282-2.015L32.552 10h-.063zM.5 3.191c.218-.017.438-.022.654-.055.45-.066.749-.37.798-.794.02-.175.033-.352.04-.529.006-.176 0-.353 0-.551h1.871v1.91h1.384V4.91H3.879v1.023c.004.532-.004 1.065.021 1.595.019.396.226.565.641.577.216.006.433 0 .682 0 0 .496.004.995-.005 1.495 0 .05-.066.12-.12.145-1.213.572-2.925-.152-3.239-1.378a3.55 3.55 0 01-.09-.818c-.01-.866-.003-1.732-.003-2.643H.5V3.189v.002zM25.19 3.306h1.505V4.96H25.19v4.916h-2.127V4.982h-1.131v-1.67h1.114V2.68c.001-1.578 1.19-2.626 2.865-2.524.543.033.815.301.815.804v.933c-.48-.002-.987-.153-1.345.242-.302.332-.193.743-.191 1.17zM16.058 9.893l-1.436-1.185c1.704-1.855 3.394-3.699 5.105-5.564l1.482 1.182-5.151 5.567zM28.023 3.256h2.089v6.566h-2.089V3.256zM17.12 4.39c0 .61-.596 1.167-1.255 1.173-.655.006-1.248-.544-1.254-1.162-.005-.614.591-1.196 1.228-1.199.662-.002 1.28.573 1.28 1.188zM29.036 2.36c-.675-.003-1.227-.538-1.22-1.181.008-.609.62-1.215 1.244-1.177.647.04 1.242.518 1.243 1.214 0 .625-.59 1.149-1.267 1.145zM18.757 8.64c-.003-.639.548-1.175 1.22-1.184.674-.009 1.262.543 1.259 1.181-.004.634-.61 1.194-1.273 1.179-.646-.014-1.205-.558-1.206-1.176z"
  }))), taxfix_defs || (taxfix_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "taxfix_svg__clip0_13385_3023"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h38v10H0z"
  })))));
}
/* harmony default export */ var taxfix = (SvgTaxfix);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/mobile/traderepublic.svg
var traderepublic_g, traderepublic_defs;
function traderepublic_extends() { traderepublic_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return traderepublic_extends.apply(this, arguments); }

function SvgTraderepublic(props) {
  return /*#__PURE__*/react.createElement("svg", traderepublic_extends({
    width: 36,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), traderepublic_g || (traderepublic_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#traderepublic_svg__clip0_13385_3083)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M35.486 4.985c-.038 1.693.278 1.248-1.401 1.699-.397.107-.812.158-1.203.278-.93.287-1.826.304-2.751-.08-.344-.144-.806-.116-1.19-.047-.882.156-1.755.367-2.622.591-.551.142-.785.062-.786-.57-.004-2.179-.016-2.14 2.165-2.69 1.181-.299 2.304-.46 3.456.077.229.107.572.043.847-.013.925-.19 1.851-.385 2.76-.633.557-.15.78-.026.73.542-.025.28-.005.563-.005.846z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M35.486 1.477c0 .893-.453 1.447-1.36 1.661-.401.095-.813.155-1.203.28-.955.31-1.876.31-2.821-.08-.325-.134-.76-.112-1.121-.046-.905.164-1.804.37-2.691.608-.613.165-.792-.03-.75-.605.038-.514.031-1.034 0-1.55-.025-.42.107-.644.561-.736 1.044-.211 2.073-.5 3.122-.686.352-.062.767.038 1.115.164.754.271 1.476.342 2.26.087.686-.225 1.427-.29 2.12-.502.675-.206.827.051.773.631-.024.256-.004.516-.004.775v-.001zM19.047 13.905V9.043c.92 0 1.82-.1 2.687.024 1.197.17 1.47 1.175.69 2.32.54.469.697 1.061.407 1.705-.307.678-.96.8-1.64.81-.696.01-1.393.003-2.144.003zm1.401-.883c.427-.147.768-.218 1.045-.387.084-.05.06-.502-.03-.545-.29-.14-.635-.174-1.015-.262v1.194zm.028-3.106v1.144c.392-.146.697-.228.96-.38.067-.039.057-.398-.016-.436-.268-.142-.577-.21-.945-.33l.001.002zM14.965 3.212c.897 0 1.694 0 2.49.002.072 0 .145.022.215.04 1.065.267 1.414 1.01 1.34 2.852-.048 1.167-.502 1.796-1.51 1.922-.693.087-1.405.068-2.107.048-.146-.004-.407-.217-.409-.337-.028-1.497-.018-2.993-.018-4.526h-.001zm1.426 1.152v2.46c.967.137 1.176-.017 1.237-.878.092-1.314-.108-1.588-1.237-1.582zM.5 13.864v-4.85c.855 0 1.675-.049 2.485.015.662.05 1.213.385 1.402 1.054.211.746.018 1.393-.708 1.888l.879 1.827c-1.32.279-1.379.236-1.913-.837-.152-.303-.118-.868-.842-.7v1.604H.5zm1.35-3.856v1.185c.45-.138.82-.232 1.165-.38.058-.025.056-.4-.004-.426-.344-.15-.715-.242-1.161-.38zM8.325 6.184l.864 1.784c-1.252.322-1.375.259-1.88-.78-.153-.315-.377-.596-.568-.893l-.25.103v1.635h-1.33V3.24c.88 0 1.785-.106 2.649.025 1.303.198 1.733 1.663.84 2.618-.095.102-.204.19-.325.302zM6.491 4.19V5.38c.44-.133.806-.222 1.147-.369.062-.026.07-.397.012-.423-.339-.153-.704-.251-1.16-.4zM14.177 9.03h1.295v2.476c0 .234-.073.516.035.691.15.243.44.561.665.558.215-.004.58-.366.603-.596.079-.767.033-1.546.034-2.32v-.801h1.284c0 1.233.087 2.471-.032 3.69-.08.812-.953 1.278-1.934 1.27-1.026-.009-1.844-.494-1.925-1.367-.109-1.179-.027-2.373-.027-3.6h.002zM23.243 3.23v1.064h-2.03c-.025.257-.042.455-.069.742h1.728V6.15h-1.679v.819h1.95c.31 1.016.23 1.125-.753 1.126-.704 0-1.409.022-2.11-.016-.177-.01-.492-.205-.495-.32-.034-1.495-.022-2.99-.022-4.53h3.479v.001zM14.49 8.07c-.692-.06-1.437.383-1.643-.607l-1.716-.004c-.201.997-.946.55-1.642.612.603-1.612 1.154-3.128 1.744-4.63.153-.389 1.406-.396 1.556-.008.58 1.506 1.115 3.027 1.702 4.636v.001zm-2.06-1.937l-.355-1.092a9.456 9.456 0 01-.158.004c-.113.349-.227.696-.353 1.088h.867zM8.326 11.957H6.648l-.068.793h2.122v1.111H5.301V9.03h3.408v1.056H6.628v.787h1.7v1.084h-.002zM10.836 12.337v1.51H9.53v-4.8c.883 0 1.756-.079 2.606.022.925.11 1.38.75 1.353 1.63-.026.859-.544 1.41-1.474 1.54-.357.05-.718.061-1.18.098zm.032-1.091c.436-.12.813-.19 1.152-.342.073-.033.067-.5-.014-.537-.337-.153-.715-.216-1.139-.329v1.208h.001zM33.886 10.117c-.546.236-.957.664-1.566.074-.32-.312-.795-.041-.861.4a5.6 5.6 0 00-.011 1.679c.105.662.66.684 1.394.056.328.14.674.286 1.016.43-.358.9-1.066 1.316-2.01 1.233-.973-.086-1.636-.606-1.752-1.499a8.754 8.754 0 01-.023-1.892c.083-.944.633-1.497 1.512-1.642 1.072-.177 1.806.174 2.3 1.16h.001zM4.536 3.237V4.3c-.415.02-.813.037-1.335.061 0 1.016-.026 2.016.01 3.014.02.534-.118.734-.721.743-.654.01-.696-.286-.684-.771.023-.98.007-1.96.007-2.98l-1.29-.061V3.237h4.013zM27.299 12.768v1.078h-3.575v-4.81h1.343v3.733h2.232zM27.934 13.867V9.046h1.3v4.82h-1.3z"
  }))), traderepublic_defs || (traderepublic_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "traderepublic_svg__clip0_13385_3083"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h35v14H0z"
  })))));
}
/* harmony default export */ var traderepublic = (SvgTraderepublic);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/n26.svg
var logos_n26_g, logos_n26_defs;
function logos_n26_extends() { logos_n26_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logos_n26_extends.apply(this, arguments); }

function n26_SvgN26(props) {
  return /*#__PURE__*/react.createElement("svg", logos_n26_extends({
    width: 41,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logos_n26_g || (logos_n26_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#n26_svg__clip0_13385_2776)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 22.538h11.043v1.459H.155L0 23.998v-1.46zM11.052 0v1.447c-.05.003-.093.006-.134.006-3.584 0-7.169 0-10.753.004-.111 0-.138-.037-.137-.156C.033.867.028.434.025 0h11.028-.001zM1.765 7.516v12.836H.026V3.584c.03-.003.064-.008.099-.008.432 0 .864 0 1.295-.002.072 0 .115.025.155.092 2.218 3.647 4.437 7.292 6.657 10.938l.975 1.6c.014.023.027.04.06.09V3.589h1.753v16.766c-.033.003-.067.008-.1.008-.412 0-.825-.001-1.238.004-.077 0-.119-.03-.162-.1-1.296-2.138-2.595-4.274-3.893-6.411L1.832 7.608c-.015-.025-.032-.046-.064-.093h-.003zM40.598 5.334c-.033.048-.054.08-.076.11L39.459 6.84c-.172-.17-.343-.325-.503-.495-.594-.634-1.297-1.03-2.113-1.134-1.498-.191-2.654.435-3.454 1.863-.429.768-.673 1.611-.825 2.492-.075.428-.12.862-.183 1.322.049-.033.076-.048.098-.068.88-.74 1.868-1.2 2.961-1.33 1.38-.167 2.666.154 3.801 1.074.886.72 1.405 1.714 1.623 2.899.239 1.287.175 2.56-.28 3.783-.668 1.806-1.85 2.955-3.585 3.314-1.498.31-2.886-.003-4.085-1.106-.696-.641-1.186-1.455-1.542-2.372-.338-.867-.534-1.777-.65-2.713a18.062 18.062 0 01-.108-2.936c.058-1.49.276-2.949.805-4.33.44-1.152 1.064-2.15 1.995-2.877a4.474 4.474 0 012.318-.939c1.425-.153 2.732.203 3.893 1.146.338.276.647.597.971.897l.002.004zm-1.357 9.398c-.022-.181-.043-.527-.112-.86-.204-1.01-.698-1.777-1.572-2.18a3.445 3.445 0 00-2.4-.204c-1.098.297-1.968 1.006-2.708 1.933a.217.217 0 00-.037.141c.037.332.068.666.125.995.142.834.37 1.636.784 2.356.713 1.24 1.68 1.968 3.06 1.805a2.848 2.848 0 001.902-1.032c.659-.782.937-1.732.958-2.953v-.002zM18.276 18.424h7.837c.003.045.009.08.009.113 0 .571-.002 1.141.003 1.712 0 .103-.024.137-.12.137-3.146-.004-6.294-.002-9.442-.004-.027 0-.055-.003-.097-.006-.002-.049-.006-.095-.006-.142.007-.54 0-1.08.027-1.617.07-1.347.482-2.535 1.337-3.518.632-.725 1.347-1.332 2.099-1.887.792-.585 1.604-1.141 2.396-1.728.56-.413 1.08-.885 1.499-1.48.424-.604.602-1.287.557-2.053-.037-.648-.19-1.242-.57-1.747-.382-.512-.887-.79-1.463-.912-1.009-.213-1.947-.017-2.794.643-.537.417-.933.965-1.2 1.63-.095.232-.194.461-.296.705-.533-.272-1.056-.541-1.577-.809.707-2.12 1.976-3.55 3.978-4.058a4.689 4.689 0 013.347.358c1.232.62 1.97 1.699 2.253 3.162.185.952.172 1.904-.113 2.835-.247.806-.688 1.467-1.229 2.052-.707.765-1.525 1.364-2.363 1.933-.857.583-1.709 1.175-2.49 1.88a7.898 7.898 0 00-.832.87c-.472.577-.67 1.125-.749 1.93l-.001.001z"
  }))), logos_n26_defs || (logos_n26_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "n26_svg__clip0_13385_2776"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h41v24H0z"
  })))));
}
/* harmony default export */ var logos_n26 = (n26_SvgN26);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/spotify.svg
var logos_spotify_g, logos_spotify_defs;
function logos_spotify_extends() { logos_spotify_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logos_spotify_extends.apply(this, arguments); }

function spotify_SvgSpotify(props) {
  return /*#__PURE__*/react.createElement("svg", logos_spotify_extends({
    width: 55,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logos_spotify_g || (logos_spotify_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#spotify_svg__clip0_13385_2785)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M.5 8.9c.008-.103.02-.203.023-.305.066-1.626.509-3.127 1.345-4.484C3.144 2.04 4.918.726 7.185.207c1.848-.422 3.646-.2 5.348.685 2.22 1.156 3.697 3.014 4.432 5.538.277.95.404 1.93.346 2.92-.205 3.47-1.747 6.04-4.605 7.687-.88.51-1.836.8-2.835.908-2.559.278-4.803-.501-6.694-2.367-1.364-1.346-2.208-3.02-2.53-4.982-.074-.454-.089-.92-.131-1.38-.003-.029-.012-.057-.018-.086v-.232L.5 8.9zm2.62-2.762c0 .564.488.965.998.804.97-.304 1.966-.44 2.971-.482a14.509 14.509 0 013.646.303c1.103.24 2.165.605 3.147 1.213a.86.86 0 00.373.12c.353.024.67-.225.774-.583.106-.365-.023-.768-.344-.955a12.545 12.545 0 00-1.268-.671C11.633 5.105 9.76 4.814 7.844 4.78c-.71-.013-1.417.034-2.122.124a11.26 11.26 0 00-2.055.444c-.33.107-.545.429-.547.792v-.002zm4.292 1.734c-.19.01-.478.016-.767.038-.287.022-.577.038-.859.096-.545.111-1.087.24-1.627.381-.313.084-.5.414-.472.73.04.43.455.73.862.595.9-.3 1.83-.423 2.769-.44.645-.013 1.288.037 1.927.143 1.295.21 2.523.622 3.65 1.347.323.208.71.102.9-.235a.713.713 0 00-.24-.957c-.29-.18-.584-.358-.889-.51-1.632-.819-3.36-1.169-5.254-1.188zm.207 2.953c-.18 0-.361-.006-.541 0-.883.035-1.753.178-2.612.39a.555.555 0 00-.422.655c.066.315.344.5.652.425.778-.19 1.564-.314 2.361-.36.775-.043 1.545 0 2.309.15.954.185 1.85.54 2.68 1.079.26.168.57.08.72-.19a.568.568 0 00-.189-.759 6.826 6.826 0 00-.406-.25c-1.422-.818-2.952-1.152-4.554-1.14h.002zM47.775 8.323v4.668c0 .19-.003.195-.181.195H46.45c-.157 0-.17-.016-.17-.187V8.315h-.53c-.178 0-.187-.01-.187-.193V7.104c0-.179.024-.204.197-.204h.51c.012-.234.013-.46.035-.685.062-.612.271-1.137.802-1.454a1.75 1.75 0 01.781-.231c.427-.032.847.01 1.26.14.09.028.122.073.122.172-.004.352 0 .704-.001 1.057 0 .164-.035.18-.182.148-.235-.052-.47-.11-.706-.12-.342-.017-.531.16-.594.52-.026.148-.02.304-.03.472h.146c.658 0 1.316.003 1.973-.003.124 0 .183.04.227.165.469 1.325.945 2.648 1.419 3.97.014.043.032.084.058.148l.86-2.63c.168-.51.336-1.017.499-1.528.03-.094.078-.125.167-.124.409.003.818 0 1.227.002.171 0 .2.045.138.217l-2.165 5.989c-.157.431-.321.859-.587 1.233-.307.433-.718.66-1.219.698a2.636 2.636 0 01-1.535-.33c-.134-.078-.146-.108-.085-.252l.389-.913c.054-.127.08-.125.205-.078.198.073.4.149.605.185.3.055.512-.107.663-.38a.41.41 0 00.03-.391c-.589-1.488-1.166-2.978-1.745-4.469-.032-.085-.07-.116-.157-.114-.325.006-.65.001-.975.003-.035 0-.07.004-.118.01l-.002-.004zM27.846 7.65c.238-.194.456-.419.71-.568.723-.422 1.473-.396 2.21-.044.888.426 1.38 1.199 1.568 2.2.146.781.105 1.557-.194 2.296-.415 1.022-1.148 1.627-2.182 1.76-.774.1-1.459-.136-2.014-.746-.025-.027-.052-.05-.098-.096V14.83c0 .182-.017.2-.186.2h-1.144c-.143 0-.165-.026-.165-.181V7.092c0-.167.016-.184.172-.184h1.155c.15 0 .166.017.168.177 0 .189.001.379.004.567 0 .007.009.013-.004-.004v.001zm1.499 4.245c.47-.006.863-.164 1.139-.548.503-.706.542-1.485.193-2.265-.474-1.06-1.807-1.19-2.484-.263-.491.671-.506 1.731-.03 2.416.298.43.701.649 1.182.66zM22.841 4.797a4.25 4.25 0 012.663.977c.16.13.163.147.049.319-.201.304-.403.61-.606.914-.088.133-.116.136-.241.04-.436-.339-.902-.609-1.438-.71-.4-.076-.798-.094-1.176.11-.344.188-.492.517-.412.92a.608.608 0 00.332.449c.31.146.627.275.95.386.44.152.892.269 1.332.424.206.072.403.189.593.306.636.395.957.995.97 1.777.012.664-.158 1.263-.598 1.751-.384.426-.863.67-1.4.765-1.481.266-2.79-.15-3.932-1.184-.108-.1-.11-.138-.019-.255l.704-.896c.098-.125.126-.128.245-.02.477.431.996.777 1.62.905.398.082.796.109 1.19-.014.307-.096.555-.271.646-.625.092-.364-.02-.678-.318-.878-.314-.209-.67-.297-1.02-.404-.484-.149-.97-.29-1.444-.468a2.166 2.166 0 01-.941-.67c-.395-.487-.487-1.07-.434-1.687.095-1.128.87-1.885 1.879-2.116.264-.061.538-.077.808-.115l-.002-.001zM35.936 6.768c1.488.02 2.714 1.035 3.032 2.56.384 1.849-.703 3.572-2.392 3.922-1.181.245-2.213-.08-3.028-1.047-.579-.688-.8-1.518-.73-2.44.107-1.38 1.048-2.604 2.451-2.909.218-.047.444-.06.665-.088l.002.002zm1.612 3.305a2.11 2.11 0 00-.224-.965c-.535-1.055-1.926-1.212-2.63-.292-.366.48-.448 1.04-.354 1.637.181 1.159 1.348 1.801 2.326 1.269.623-.34.86-.933.882-1.65zM39.853 8.314h-.551c-.151 0-.17-.02-.17-.176V7.082c0-.146.025-.171.163-.173h.552c.003-.053.006-.099.006-.144v-1.34c0-.162.018-.182.163-.182.392 0 .785.003 1.178-.002.116 0 .157.046.155.167-.004.458 0 .919-.002 1.377 0 .096.023.126.114.124a81.44 81.44 0 011.238-.001c.157 0 .175.019.176.184 0 .351-.003.703.002 1.055.001.121-.04.168-.156.167-.416-.005-.834 0-1.251-.004-.09 0-.125.02-.125.128.005.914.002 1.828.003 2.744 0 .077.007.154.022.229.05.27.232.416.525.426.265.008.517-.049.756-.17.144-.072.202-.033.204.133 0 .335-.003.67.001 1.006.002.102-.04.154-.119.2-.423.243-.879.318-1.35.271a2.252 2.252 0 01-.707-.174c-.522-.238-.74-.72-.805-1.291-.022-.187-.023-.377-.025-.566-.003-.924 0-1.845 0-2.769v-.165l.003.002zM43.469 10.044V7.107c0-.182.014-.198.186-.198h1.143c.154 0 .173.022.173.187v5.9c0 .174-.013.188-.18.188h-1.155c-.151 0-.166-.015-.166-.177v-2.963h-.001zM43.293 5.146c0-.56.406-.995.93-.995s.942.445.939 1.002c-.002.553-.416.995-.935.995-.528 0-.934-.435-.934-1.004v.002z"
  }))), logos_spotify_defs || (logos_spotify_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "spotify_svg__clip0_13385_2785"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h54v18H0z"
  })))));
}
/* harmony default export */ var logos_spotify = (spotify_SvgSpotify);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/sumup.svg
var logos_sumup_g, logos_sumup_defs;
function logos_sumup_extends() { logos_sumup_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logos_sumup_extends.apply(this, arguments); }

function sumup_SvgSumup(props) {
  return /*#__PURE__*/react.createElement("svg", logos_sumup_extends({
    width: 62,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logos_sumup_g || (logos_sumup_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#sumup_svg__clip0_13385_2752)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M18.35 0H1.865C1.12 0 .5.65.5 1.428V18.57C.5 19.35 1.121 20 1.866 20h16.483c.745 0 1.366-.65 1.366-1.429V1.428C19.715.617 19.095 0 18.35 0zm-5.805 15.032c-1.676 1.753-4.345 1.819-6.116.227l-.031-.033c-.093-.098-.125-.293 0-.422l5.96-6.2a.314.314 0 01.404 0c1.552 1.882 1.49 4.674-.217 6.427v.001zm1.241-9.902l-5.96 6.2a.314.314 0 01-.404 0C5.87 9.48 5.932 6.69 7.61 4.936c1.675-1.753 4.345-1.819 6.115-.227 0 0 .032 0 .032.033.155.098.155.293.031.39l-.001-.001z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.098 9.026c-.838-.357-1.366-.583-1.366-1.104 0-.422.31-.812 1.024-.812.435 0 .808.195 1.086.584.187.227.373.357.59.357a.779.779 0 00.776-.779c0-.162-.031-.324-.125-.421-.466-.747-1.427-1.267-2.328-1.267-1.242 0-2.515.812-2.515 2.371s1.243 2.111 2.267 2.5c.807.324 1.52.616 1.52 1.299 0 .52-.466 1.038-1.334 1.038-.28 0-.776-.064-1.117-.487-.187-.227-.403-.325-.59-.325a.8.8 0 00-.776.78.8.8 0 00.155.454c.466.747 1.52 1.104 2.328 1.104 1.366 0 2.857-.91 2.857-2.564-.032-1.753-1.366-2.305-2.452-2.728zm30.795-3.475h-.031c-1.49 0-2.67 1.234-2.67 2.76v9.61c0 .421.341.778.745.778.403 0 .744-.357.744-.779v-3.993c.28.26.745.39 1.18.39h.03c1.492 0 2.61-1.331 2.61-2.857V8.246c0-1.526-1.118-2.695-2.61-2.695h.002zm1.18 5.975c0 .845-.528 1.202-1.15 1.202h-.031c-.651 0-1.15-.357-1.15-1.202V8.312c0-.65.529-1.202 1.15-1.202h.031c.652 0 1.15.52 1.15 1.202v3.214zM45.14 5.55h-.032c-.744 0-1.397.325-1.862.812a2.623 2.623 0 00-1.862-.812h-.031c-1.428 0-2.608 1.202-2.608 2.728v5.292c.031.421.341.747.744.747.403 0 .715-.324.745-.747V8.279c0-.65.496-1.169 1.117-1.169h.032c.621 0 1.086.488 1.117 1.136v5.325c.037.384.297.747.715.747s.714-.324.744-.747V8.215c.032-.617.528-1.136 1.118-1.136h.031c.622 0 1.118.519 1.118 1.169v5.324c.032.422.342.748.745.748.403 0 .714-.325.744-.748V8.281c.032-1.493-1.149-2.728-2.576-2.728l.001-.002zm-8.817 0c-.403 0-.715.325-.745.748v5.291c0 .65-.496 1.17-1.149 1.17H34.4c-.621 0-1.15-.52-1.15-1.17V6.266c-.03-.422-.34-.748-.744-.748-.403 0-.714.325-.745.748v5.291c0 1.493 1.18 2.728 2.639 2.728h.031c1.46 0 2.639-1.233 2.639-2.728V6.3a.745.745 0 00-.745-.748zm17.633 0c-.403 0-.715.325-.745.748v5.291c0 .65-.496 1.17-1.149 1.17h-.031c-.622 0-1.15-.52-1.15-1.17V6.266c-.031-.422-.341-.748-.744-.748-.403 0-.715.325-.745.748v5.291c0 1.493 1.18 2.728 2.639 2.728h.031c1.46 0 2.638-1.233 2.638-2.728V6.3c-.031-.422-.341-.748-.744-.748z"
  }))), logos_sumup_defs || (logos_sumup_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "sumup_svg__clip0_13385_2752"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h61v20H0z"
  })))));
}
/* harmony default export */ var logos_sumup = (sumup_SvgSumup);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/taxfix.svg
var logos_taxfix_g, logos_taxfix_defs;
function logos_taxfix_extends() { logos_taxfix_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logos_taxfix_extends.apply(this, arguments); }

function taxfix_SvgTaxfix(props) {
  return /*#__PURE__*/react.createElement("svg", logos_taxfix_extends({
    width: 52,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logos_taxfix_g || (logos_taxfix_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#taxfix_svg__clip0_13385_2738)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M12.323 14c-.418-.073-.852-.101-1.254-.225-1.977-.608-2.986-2-3.302-3.904-.234-1.419.074-2.741.931-3.926 1.159-1.603 3.56-2.248 5.229-1.383.377.195.69.505 1.06.784v-.858H17.8v9.169h-2.784v-1.173c-.596 1.049-1.49 1.396-2.523 1.516h-.173.002zm-1.689-4.974l.042.005c0 .151-.01.303 0 .454.075 1.07.862 1.94 1.844 2.043 1.117.116 2.019-.46 2.343-1.518a3.128 3.128 0 00-.063-2.072c-.339-.894-1.155-1.371-2.2-1.312-.876.05-1.6.636-1.823 1.506-.076.29-.098.596-.143.894zM43.774 14l-1.905-1.722 3.19-3.042-3.06-2.925 1.878-1.831c1.009.972 2.008 1.937 3.046 2.936l3.076-2.968c.62.594 1.229 1.176 1.844 1.767l-3.038 2.912 3.197 3.08L50.066 14h-.087c-1.05-.95-2.102-1.897-3.123-2.82L43.861 14h-.087zM0 4.467c.298-.024.599-.03.895-.076.615-.093 1.025-.518 1.091-1.112.028-.246.046-.493.055-.74.009-.248.001-.495.001-.772h2.56V4.44h1.893v2.433h-1.87c0 .503-.003.968 0 1.432.005.746-.006 1.491.028 2.234.025.554.309.79.877.806.296.01.592 0 .933 0 0 .696.005 1.394-.007 2.095 0 .07-.09.167-.163.202-1.662.801-4.003-.213-4.433-1.929a5.083 5.083 0 01-.123-1.145c-.014-1.212-.005-2.425-.005-3.7H0V4.463v.003zM33.788 4.628h2.059v2.317h-2.06v6.883h-2.91V6.975h-1.549V4.636h1.525v-.883c.002-2.21 1.629-3.676 3.92-3.533.744.046 1.115.421 1.115 1.125v1.307c-.656-.004-1.35-.214-1.84.338-.413.465-.263 1.04-.262 1.638h.002zM21.29 13.85l-1.965-1.659c2.331-2.597 4.644-5.178 6.986-7.79.679.554 1.337 1.093 2.028 1.655L21.29 13.85zM37.663 4.558h2.858v9.193h-2.858V4.558zM22.742 6.145c0 .856-.814 1.635-1.716 1.643-.896.01-1.708-.761-1.715-1.627-.008-.859.808-1.674 1.68-1.678.905-.003 1.751.802 1.751 1.662zM39.049 3.305c-.924-.005-1.68-.754-1.669-1.655.01-.852.848-1.7 1.701-1.647.886.056 1.7.725 1.702 1.7 0 .874-.809 1.608-1.734 1.602zM24.983 12.097c-.003-.895.751-1.646 1.67-1.658.923-.013 1.728.76 1.722 1.653-.005.887-.833 1.671-1.74 1.65-.885-.019-1.65-.78-1.652-1.646v.001z"
  }))), logos_taxfix_defs || (logos_taxfix_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "taxfix_svg__clip0_13385_2738"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v14H0z"
  })))));
}
/* harmony default export */ var logos_taxfix = (taxfix_SvgTaxfix);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/logos/traderepublic.svg
var logos_traderepublic_g, logos_traderepublic_defs;
function logos_traderepublic_extends() { logos_traderepublic_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logos_traderepublic_extends.apply(this, arguments); }

function traderepublic_SvgTraderepublic(props) {
  return /*#__PURE__*/react.createElement("svg", logos_traderepublic_extends({
    width: 48,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logos_traderepublic_g || (logos_traderepublic_g = /*#__PURE__*/react.createElement("g", {
    fill: "#C3C6C5",
    clipPath: "url(#traderepublic_svg__clip0_13385_2798)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M47.98 7.121c-.052 2.418.38 1.783-1.921 2.427-.545.153-1.113.226-1.65.398-1.277.41-2.505.434-3.774-.116-.47-.204-1.104-.164-1.632-.066-1.209.223-2.406.524-3.595.845-.755.203-1.077.088-1.078-.814-.005-3.113-.022-3.058 2.969-3.844 1.62-.426 3.16-.657 4.74.11.313.153.784.062 1.162-.018 1.268-.272 2.538-.55 3.786-.904.763-.216 1.07-.038 1 .773-.034.4-.006.806-.006 1.209z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M47.98 2.11c0 1.276-.621 2.067-1.865 2.373-.55.135-1.115.22-1.65.4-1.31.442-2.572.444-3.869-.114-.445-.191-1.04-.16-1.537-.066-1.24.234-2.474.528-3.691.869-.84.235-1.085-.042-1.028-.864.052-.735.043-1.478 0-2.214-.034-.6.147-.92.77-1.052 1.432-.302 2.842-.716 4.28-.98.483-.09 1.053.054 1.53.234 1.034.387 2.024.488 3.1.123.94-.32 1.956-.414 2.906-.716.927-.294 1.135.073 1.061.901-.033.367-.005.738-.005 1.108l-.001-.003zM25.436 19.865v-6.946c1.262 0 2.497-.142 3.684.034 1.642.242 2.016 1.678.946 3.314.742.67.957 1.516.559 2.436-.42.968-1.316 1.144-2.25 1.158-.954.014-1.909.004-2.94.004zm1.922-1.262c.585-.21 1.052-.312 1.432-.553.115-.073.082-.717-.04-.778-.4-.2-.872-.25-1.392-.376v1.707zm.038-4.438V15.8c.537-.208.956-.325 1.315-.542.093-.056.079-.57-.021-.624-.367-.202-.792-.299-1.296-.47l.002.001zM19.838 4.59c1.23 0 2.324-.002 3.416.002.098 0 .198.03.294.056 1.461.381 1.94 1.443 1.837 4.075-.064 1.667-.687 2.566-2.07 2.746-.95.124-1.927.097-2.89.069-.2-.007-.558-.31-.56-.483-.04-2.137-.026-4.275-.026-6.465h-.001zm1.956 1.644V9.75c1.326.194 1.613-.026 1.696-1.256.127-1.877-.147-2.268-1.696-2.26zM0 19.806v-6.93c1.173 0 2.297-.068 3.409.022.908.073 1.662.55 1.922 1.506.29 1.066.024 1.99-.971 2.698l1.205 2.61c-1.81.398-1.89.337-2.624-1.196-.207-.433-.162-1.24-1.154-1v2.291H0v-.001zm1.851-5.51v1.694c.617-.197 1.126-.332 1.598-.543.08-.036.077-.57-.005-.61-.472-.212-.981-.344-1.593-.54zM10.731 8.835l1.185 2.548c-1.717.46-1.886.37-2.579-1.115-.209-.45-.516-.851-.779-1.275l-.341.147v2.335H6.39V4.63c1.209 0 2.448-.152 3.634.035 1.786.284 2.376 2.375 1.152 3.74-.13.146-.28.273-.446.432v-.001zM8.215 5.984v1.704c.603-.19 1.106-.318 1.574-.527.085-.039.095-.568.017-.605-.465-.219-.966-.359-1.59-.572zM18.756 12.9h1.777c0 1.213-.002 2.374 0 3.537 0 .334-.102.738.046.988.206.347.606.801.913.796.294-.005.794-.522.827-.851.108-1.095.045-2.208.047-3.313V12.91h1.76c0 1.762.12 3.531-.043 5.272-.109 1.16-1.308 1.826-2.653 1.814-1.406-.012-2.528-.705-2.64-1.953-.15-1.684-.036-3.39-.036-5.143h.002zM31.19 4.613v1.522h-2.785l-.094 1.06h2.37v1.589h-2.303v1.17h2.674c.426 1.452.317 1.608-1.033 1.61-.965 0-1.93.03-2.892-.024-.244-.014-.676-.293-.68-.458-.047-2.135-.03-4.271-.03-6.47h4.771l.001.001zM19.187 11.529c-.95-.087-1.971.547-2.254-.868l-2.354-.005c-.276 1.424-1.296.786-2.25.874.826-2.303 1.582-4.469 2.391-6.614.209-.555 1.928-.566 2.134-.012.795 2.152 1.53 4.325 2.333 6.624zM16.362 8.76l-.487-1.56a12.37 12.37 0 01-.218.007l-.484 1.553h1.19zM10.733 17.081H8.431l-.093 1.134h2.91v1.587H6.585V12.9h4.674v1.51H8.404v1.124h2.33v1.548zM14.175 17.624v2.157h-1.79v-6.856c1.21 0 2.408-.114 3.573.03 1.269.158 1.893 1.073 1.856 2.328-.035 1.228-.745 2.015-2.022 2.2-.489.072-.984.088-1.618.14h.001zm.044-1.558c.598-.171 1.116-.271 1.58-.49.1-.046.092-.714-.02-.766-.46-.218-.98-.309-1.56-.47v1.726zM45.786 14.453c-.75.336-1.313.949-2.147.105-.44-.445-1.092-.058-1.182.57-.112.787-.134 1.616-.015 2.4.145.947.906.978 1.912.08l1.393.616c-.49 1.285-1.461 1.88-2.755 1.76-1.336-.122-2.245-.866-2.404-2.14a13.028 13.028 0 01-.031-2.704c.114-1.349.867-2.139 2.073-2.345 1.471-.253 2.478.247 3.155 1.656l.001.002zM5.535 4.625v1.517l-1.831.088c0 1.451-.036 2.88.014 4.306.026.762-.163 1.048-.99 1.06-.896.014-.954-.408-.938-1.1.032-1.4.01-2.8.01-4.257L.03 6.151V4.625h5.505zM36.752 18.24v1.54H31.85v-6.87h1.842v5.331h3.062-.002zM37.623 19.81v-6.888h1.783v6.888h-1.783z"
  }))), logos_traderepublic_defs || (logos_traderepublic_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "traderepublic_svg__clip0_13385_2798"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v20H0z"
  })))));
}
/* harmony default export */ var logos_traderepublic = (traderepublic_SvgTraderepublic);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/CompanyLogos.tsx

function CompanyLogos_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 1118px;\n  margin: auto;\n  flex-wrap: wrap;\n  gap: ",
        "px;\n  padding: ",
        ";\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    CompanyLogos_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyLogos_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  padding: ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    CompanyLogos_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






























function CompanyLogos() {
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    if (mobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogos_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyLogos_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(taxfix, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sumup, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_meta, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_ey, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(n26, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spotify, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(traderepublic, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flaconi, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_airbnb, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_jll, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_getyourguide, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_bain, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_doctolib, {})
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogos_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyLogos_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_taxfix, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_sumup, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(meta, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ey, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_n26, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_spotify, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(logos_traderepublic, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(flaconi, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(airbnb, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jll, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(getyourguide, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(bain, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(doctolib, {})
            ]
        })
    });
}
var CompanyLogos_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(CompanyLogos_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var CompanyLogos_Container = styled_components_browser_esm/* default.div */.ZP.div(CompanyLogos_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3, 0);
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/facebook.svg
var _path;
function facebook_extends() { facebook_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_extends.apply(this, arguments); }

function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", facebook_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.757 2.757A6 6 0 0115 1h3a1 1 0 011 1v4a1 1 0 01-1 1h-3v2h3a1 1 0 01.97 1.242l-1 4A1 1 0 0117 15h-2v7a1 1 0 01-1 1h-4a1 1 0 01-1-1v-7H7a1 1 0 01-1-1v-4a1 1 0 011-1h2V7a6 6 0 011.757-4.243zM15 3a4 4 0 00-4 4v3a1 1 0 01-1 1H8v2h2a1 1 0 011 1v7h2v-7a1 1 0 011-1h2.22l.5-2H14a1 1 0 01-1-1V7a2 2 0 012-2h2V3h-2z",
    fill: "#fff"
  })));
}
/* harmony default export */ var facebook = (SvgFacebook);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/linkedin.svg
var linkedin_g;
function linkedin_extends() { linkedin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedin_extends.apply(this, arguments); }

function SvgLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", linkedin_extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), linkedin_g || (linkedin_g = /*#__PURE__*/react.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.667 8.25a4.583 4.583 0 00-4.583 4.584v5.5h1.833v-5.5a2.75 2.75 0 115.5 0v5.5h1.833v-5.5a4.584 4.584 0 00-4.583-4.584zm0-1.833a6.417 6.417 0 00-6.417 6.417v6.416c0 .507.41.917.917.917h3.667c.506 0 .916-.41.916-.917v-6.416a.917.917 0 111.834 0v6.416c0 .507.41.917.916.917h3.667c.506 0 .917-.41.917-.917v-6.416a6.417 6.417 0 00-6.417-6.417zM.917 8.25c0-.506.41-.916.917-.916H5.5c.507 0 .917.41.917.916v11c0 .507-.41.917-.917.917H1.834a.917.917 0 01-.917-.917v-11zm1.833.917v9.167h1.834V9.167H2.75zM3.667 2.75a.917.917 0 100 1.834.917.917 0 000-1.834zm-2.75.917a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0z"
  }))));
}
/* harmony default export */ var linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/twitter.svg
var twitter_g, twitter_defs;
function twitter_extends() { twitter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }

function SvgTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), twitter_g || (twitter_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_13107_1340)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7.608 20.075c-2.383 0-4.858-.642-7.058-1.925-.367-.184-.55-.642-.458-1.009a.88.88 0 01.825-.641c1.558.091 3.116-.275 4.491-.917-3.391-2.108-4.308-5.042-4.4-7.333-.091-2.659.825-4.859.917-4.95.092-.275.367-.55.733-.55.367 0 .642.091.825.366 1.559 2.2 3.942 3.575 6.6 3.759 0-1.467.642-2.842 1.742-3.85a5.142 5.142 0 016.692 0 9.236 9.236 0 002.108-1.1c.275-.184.733-.184 1.008 0 .275.183.459.641.367 1.008-.275 1.283-.917 2.475-1.833 3.483v.459c0 5.041-2.2 9.258-6.142 11.458-1.925 1.192-4.125 1.742-6.417 1.742zm-3.025-2.2c3.025.733 6.05.366 8.617-1.1 3.3-1.925 5.225-5.592 5.225-9.9 0-.184 0-.367-.092-.55-.091-.275 0-.642.275-.825.184-.184.367-.459.55-.642-.183.092-.458.183-.641.183-.367.092-.734 0-.917-.275-1.192-1.283-3.208-1.466-4.492-.275-.825.55-1.191 1.467-1.191 2.384v.916a.919.919 0 01-.917.917A10.44 10.44 0 013.117 5.5c-.55 2.383-.734 6.875 4.583 9.166.275.184.55.459.55.825 0 .367-.092.642-.367.825-1.1.734-2.2 1.284-3.3 1.559z",
    fill: "#fff"
  }))), twitter_defs || (twitter_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "twitter_svg__clip0_13107_1340"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}
/* harmony default export */ var twitter = (SvgTwitter);
// EXTERNAL MODULE: ./src/shared/components/CookieContextProvider.tsx + 1 modules
var CookieContextProvider = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/shared/components/Locale.js
var Locale = __webpack_require__(20486);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var components_Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Footer.tsx

function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  display: flex;\n  align-items: start;\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: inherit;\n  border: inherit;\n  line-height: 23px;\n  height: inherit;\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-block;\n\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    Footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Footer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  color: white;\n  border: none;\n"
    ]);
    Footer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Footer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    Footer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Footer_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: flex;\n\n  ",
        " {\n    margin: ",
        ";\n    display: flex;\n    text-decoration: none;\n    list-style: none;\n    padding: 0;\n    align-items: center;\n  }\n"
    ]);
    Footer_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Footer_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    Footer_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Footer_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  cursor: pointer;\n  margin: ",
        ";\n"
    ]);
    Footer_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Footer_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    Footer_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Footer_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #9cba6c;\n  text-decoration: none;\n"
    ]);
    Footer_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}















var YEAR = new Date().getFullYear();
function Footer() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var context = (0,react.useContext)(CookieContextProvider/* CookieContext */.U);
    var smUp = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    if (!context) {
        // Handle the case where context is undefined
        throw new Error("CookieContext is not available");
    }
    var detailsOpen = context.detailsOpen, setDetailsOpen = context.setDetailsOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
            className: "main-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    alt: "",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                style: {
                                    fontSize: "12px"
                                },
                                color: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locale/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                                as: "nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "sr-only",
                                        children: "Social Links"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.linkedin.com/company/heycater/",
                                        "aria-label": "Linkedin",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.facebook.com/heycater",
                                        "aria-label": "Facebook",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://twitter.com/HeyHeycater",
                                        "aria-label": "Twitter",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                        style: {
                            flexDirection: "column"
                        },
                        as: "nav",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                            style: {
                                flexDirection: smUp ? "row" : "column"
                            },
                            as: "ul",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/impressum",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.imprint")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/agb",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.terms")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/datenschutz",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.privacy")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        as: "button",
                                        onClick: function() {
                                            return setDetailsOpen(!detailsOpen);
                                        },
                                        children: "Cookies"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: constants/* LINKS.career */.BA.career,
                                        rel: "noopener",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerLink, {
                                            target: "_blank",
                                            children: t("common:navigation.career")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/hub",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.blog")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/caterer",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLink, {
                                            children: [
                                                "\uD83E\uDDD1‍\uD83C\uDF73 ",
                                                t("common:navigation.partner")
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTypography, {
                        pt: 2,
                        fontSize: 12,
                        children: [
                            YEAR,
                            " Hey Group GmbH"
                        ]
                    })
                ]
            })
        })
    });
}
var NavListItem = styled_components_browser_esm/* default.li */.ZP.li(Footer_templateObject());
var StyledLink = styled_components_browser_esm/* default.a */.ZP.a(Footer_templateObject1(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var StyledFooter = styled_components_browser_esm/* default.div */.ZP.div(Footer_templateObject2(), function(props) {
    return props.theme.spacing(4, 0);
}, function(props) {
    return props.theme.palette.text.primary;
});
var FooterWrapper = styled_components_browser_esm/* default.div */.ZP.div(Footer_templateObject3(), function(props) {
    return props.theme.breakpoints.down("xs");
});
var FooterColumn = styled_components_browser_esm/* default.div */.ZP.div(Footer_templateObject4(), function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1, 0);
});
var FooterLink = styled_components_browser_esm/* default.a */.ZP.a(Footer_templateObject5(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var FooterSocialIconLink = styled_components_browser_esm/* default.a */.ZP.a(Footer_templateObject6(), function(props) {
    return props.theme.spacing(0, 1.75);
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(Footer_templateObject7(), function(props) {
    return props.theme.palette.grey[400];
});
var CareerLink = (0,styled_components_browser_esm/* default */.ZP)(FooterLink)(Footer_templateObject8());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/EmbeddedQuestion.tsx + 19 modules
var EmbeddedQuestion = __webpack_require__(13792);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/SelectedAnswers.tsx
var SelectedAnswers = __webpack_require__(62295);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var schema_steps = __webpack_require__(82546);
// EXTERNAL MODULE: ./src/static_pages/home/components/Hero/ProgressIndicator.tsx
var ProgressIndicator = __webpack_require__(41232);
;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/variationA/EmbeddedQuestionControls.tsx

function EmbeddedQuestionControls_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    EmbeddedQuestionControls_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmbeddedQuestionControls_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        "px;\n"
    ]);
    EmbeddedQuestionControls_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var EmbeddedQuestionControls = function(param) {
    var onBackground = param.onBackground;
    var ref = (0,context/* useQualification */._8)(), state = ref.state, actions = ref.actions, canContinue = ref.canContinue;
    var toPrevStep = (0,react.useCallback)(function() {
        actions.prevStep();
    }, []);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    if (state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered && state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering && state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        return null;
    }
    var step = state.status === model/* QUALIFICATION_STATUS.answering */.w.answering ? state.qualification.step : null;
    var steps = state.qualification.steps;
    var stepIndex = step ? steps.findIndex(function(param) {
        var id = param.id;
        return id === step.id;
    }) : -1;
    var prevStep = steps[stepIndex - 1];
    var isLastStep = Boolean(step && stepIndex === steps.length - 1);
    var enabledSteps = state.qualification.steps.filter(function(q) {
        return !q.disabled;
    });
    var hideNextBtn = function() {
        if (state.status !== "answering") return false;
        var customerTierABCExperiment = (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB) || (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC);
        if (customerTierABCExperiment && state.qualification.step.id === schema_steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id) return true;
        return false;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
            size: "sm",
            display: "flex",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    display: {
                        xs: "none",
                        sm: "block"
                    },
                    visibility: state.status === model/* QUALIFICATION_STATUS.answered */.w.answered ? "hidden" : "visible",
                    mb: {
                        xs: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressIndicator/* default */.Z, {
                        currentStep: state.status === model/* QUALIFICATION_STATUS.answering */.w.answering ? state.qualification.stepIndex + 1 : enabledSteps.length,
                        stepCount: enabledSteps.length
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsWrapper, {
                    visibility: state.status === model/* QUALIFICATION_STATUS.answered */.w.answered ? "hidden" : "visible",
                    children: [
                        prevStep && !prevStep.disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedButton, {
                            id: "embedded-funnel__prev-btn",
                            variant: onBackground === "dark" ? "tertiary" : "secondary",
                            rounded: true,
                            onClick: toPrevStep,
                            children: t("common:labels.back")
                        }),
                        hideNextBtn ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedButton, {
                                variant: "primary",
                                type: "submit",
                                id: "embedded-funnel__next-btn",
                                disabled: !canContinue,
                                rounded: true,
                                children: isLastStep ? t("qualification:lastQuestionCTAShort") : t("common:labels.next")
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var EmbeddedButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(EmbeddedQuestionControls_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1, 3);
});
var ButtonsWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(EmbeddedQuestionControls_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
/* harmony default export */ var variationA_EmbeddedQuestionControls = (EmbeddedQuestionControls);

;// CONCATENATED MODULE: ./src/shared/components/EmbeddedFunnel/variationA/EmbeddedQuestionLayout.tsx




function EmbeddedQuestionLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: ",
        "px;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    padding: ",
        "px;\n  }\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    EmbeddedQuestionLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmbeddedQuestionLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 1rem;\n  ",
        " {\n    gap: 0;\n  }\n"
    ]);
    EmbeddedQuestionLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmbeddedQuestionLayout_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--embedded-text-color, inherit);\n"
    ]);
    EmbeddedQuestionLayout_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmbeddedQuestionLayout_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 14px;\n  white-space: pre-line;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    EmbeddedQuestionLayout_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









// Minimal height, that avoids height changes between questions.
var MIN_HEIGHT_OVER_MD = "670px";
var EmbeddedQuestionLayout = function(_param) {
    var title = _param.title, subtitle = _param.subtitle, content = _param.content, _containerSize = _param.containerSize, containerSize = _containerSize === void 0 ? "sm" : _containerSize, disableGutters = _param.disableGutters, _answerContainerSize = _param.answerContainerSize, answerContainerSize = _answerContainerSize === void 0 ? 826 : _answerContainerSize, side = _param.side, wrapper = _param.wrapper, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "subtitle",
        "content",
        "containerSize",
        "disableGutters",
        "answerContainerSize",
        "side",
        "wrapper"
    ]);
    var state = (0,context/* useQualification */._8)().state;
    if (state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered && state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering && state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        return null;
    }
    var step = state.status === model/* QUALIFICATION_STATUS.answering */.w.answering ? state.qualification.step : null;
    var steps = state.qualification.steps;
    var stepIndex = step ? steps.findIndex(function(param) {
        var id = param.id;
        return id === step.id;
    }) : -1;
    var showSelectedAnswerPills = state.status === model/* QUALIFICATION_STATUS.answering */.w.answering && stepIndex > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: containerSize,
        disableGutters: disableGutters
    }, boxProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmbeddedQuestionLayout_Wrapper, {
            bgcolor: wrapper === "white" ? "white" : "transparent",
            minHeight: {
                xs: 0,
                md: MIN_HEIGHT_OVER_MD
            },
            display: "flex",
            width: "100%",
            color: "rgba(0,0,0,0.8)",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBox, {
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row"
                    },
                    alignItems: {
                        xs: "center",
                        md: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            flexGrow: 0,
                            width: {
                                xs: "100%",
                                md: "min-content"
                            },
                            maxWidth: "500px",
                            children: side
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignSelf: "stretch",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                            textAlign: "center",
                                            mb: 2,
                                            maxWidth: 650,
                                            mx: "auto",
                                            children: typeof title === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmbeddedQuestionLayout_Subtitle, {
                                                variant: "subtitle2",
                                                children: [
                                                    title,
                                                    "\xa0"
                                                ]
                                            }) : title
                                        }),
                                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                            as: "p",
                                            textAlign: "center",
                                            children: [
                                                subtitle,
                                                "\xa0"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                    my: {
                                        xs: 4,
                                        sm: 5
                                    },
                                    children: content
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(variationA_EmbeddedQuestionControls, {
                                        onBackground: "light"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                showSelectedAnswerPills ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container/* default */.Z, {
                    mt: {
                        xs: 4,
                        sm: 5
                    },
                    size: answerContainerSize,
                    disableGutters: disableGutters,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        bgcolor: "white",
                        borderRadius: {
                            xs: 0,
                            sm: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedAnswers/* default */.Z, {
                            currentStep: step || steps[1]
                        })
                    })
                }) : null
            ]
        })
    }));
};
var EmbeddedQuestionLayout_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(EmbeddedQuestionLayout_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var WrapperBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(EmbeddedQuestionLayout_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var TextWrapper = styled_components_browser_esm/* default.div */.ZP.div(EmbeddedQuestionLayout_templateObject2());
var EmbeddedQuestionLayout_Subtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(EmbeddedQuestionLayout_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var variationA_EmbeddedQuestionLayout = (EmbeddedQuestionLayout);

// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/LoadingIndicator.tsx + 1 modules
var LoadingIndicator = __webpack_require__(61654);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/EmbeddedFunnel.jsx

function EmbeddedFunnel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --embedded-text-color: ",
        ";\n  width: 100%;\n  position: relative;\n\n  :focus,\n  :focus-visible {\n    outline: none;\n  }\n"
    ]);
    EmbeddedFunnel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var stepTitleMappingVariationA = {
    catering_categories: "qualification:embeddedFunnel.cateringCategories.variationA.title",
    city: "qualification:embeddedFunnel.city.title",
    dietary_restrictions: "qualification:embeddedFunnel.dietaryRestrictions.title",
    event_date: "qualification:embeddedFunnel.eventDate.title",
    people_count_and_budget: "qualification:embeddedFunnel.budgetAndPeople.title",
    customer_tier: "qualification:customerTier.title",
    rare_customer_tier: "qualification:rareCustomerTier.title"
};
var EmbeddedRequestPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3234), __webpack_require__.e(8184), __webpack_require__.e(1507), __webpack_require__.e(5627), __webpack_require__.e(8832), __webpack_require__.e(2719), __webpack_require__.e(3644)]).then(__webpack_require__.bind(__webpack_require__, 43644));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43644)
            ];
        }
    }
});

// eslint-disable-next-line react/display-name
var EmbeddedFunnel = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var onBackground = param.onBackground, highlightColor = param.highlightColor, ratings = param.ratings, slides = param.slides, renderTitle = param.renderTitle, _titleTranslationKeys = param.titleTranslationKeys, titleTranslationKeys = _titleTranslationKeys === void 0 ? stepTitleMappingVariationA : _titleTranslationKeys, _LayoutComponent = param.LayoutComponent, LayoutComponent = _LayoutComponent === void 0 ? variationA_EmbeddedQuestionLayout : _LayoutComponent;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6;
    var scrollHelperRef = (0,react.useRef)(null);
    var onQuestionChange = (0,react.useCallback)(function() {
        if (scrollHelperRef && (scrollHelperRef === null || scrollHelperRef === void 0 ? void 0 : scrollHelperRef.current)) {
            scrollHelperRef.current.scrollIntoView({
                inline: "nearest",
                block: "nearest",
                behavior: "smooth"
            });
        }
    }, []);
    var _$ref7 = (0,context/* useQualification */._8)({
        onQuestionChange: onQuestionChange
    }), state = _$ref7.state, actions = _$ref7.actions, canContinue = _$ref7.canContinue;
    (0,react.useEffect)(function() {
        if (scrollHelperRef && (scrollHelperRef === null || scrollHelperRef === void 0 ? void 0 : scrollHelperRef.current)) {
            scrollHelperRef.current.scrollIntoView({
                inline: "nearest",
                block: "nearest",
                behavior: "smooth"
            });
        }
    }, [
        state.status
    ]);
    var toNextStep = (0,react.useCallback)(function() {
        actions.nextStep();
    }, [
        actions
    ]);
    (0,react.useEffect)(function() {
        if (state.status === model/* QUALIFICATION_STATUS.qualifiedForMarketplace */.w.qualifiedForMarketplace) {
            (0,urls/* redirectToMarketplace */.c9)(state.marketplaceUrl);
        }
    }, [
        state
    ]);
    if (state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered && state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering && state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        return null;
    }
    var stepId = state.status === "answering" && ((_$ref = state.qualification.step) === null || _$ref === void 0 ? void 0 : _$ref.id) || "";
    var onKeyPress = function(event) {
        if (event.key === "Enter" && canContinue) {
            event.preventDefault();
            toNextStep();
        }
    };
    if (state.status === model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedRequestPage, {
            ratings: ratings
        });
    }
    var textColor = onBackground === "light" ? "dark" : "light";
    if (stepId.includes("customer-") && (slides === null || slides === void 0 ? void 0 : (_$ref1 = slides.customerTier) === null || _$ref1 === void 0 ? void 0 : _$ref1.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "city" && (slides === null || slides === void 0 ? void 0 : (_$ref2 = slides.city) === null || _$ref2 === void 0 ? void 0 : _$ref2.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "catering_categories" && (slides === null || slides === void 0 ? void 0 : (_$ref3 = slides.category) === null || _$ref3 === void 0 ? void 0 : _$ref3.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "people_count_and_budget" && (slides === null || slides === void 0 ? void 0 : (_$ref4 = slides.budgetAndPeople) === null || _$ref4 === void 0 ? void 0 : _$ref4.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "dietary_restrictions" && (slides === null || slides === void 0 ? void 0 : (_$ref5 = slides.dietaryRestriction) === null || _$ref5 === void 0 ? void 0 : _$ref5.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "event_date" && (slides === null || slides === void 0 ? void 0 : (_$ref6 = slides.dateAndLead) === null || _$ref6 === void 0 ? void 0 : _$ref6.whiteWrapper)) {
        textColor = "dark";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormWrapper, {
        $textColor: textColor,
        tabIndex: 0,
        ref: ref,
        "data-embedded-funnel": true,
        name: "step" in state.qualification ? state.qualification.step.id : state.status,
        onSubmit: function(e) {
            e.preventDefault();
            toNextStep();
        },
        onKeyPressCapture: onKeyPress,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                position: "absolute",
                top: "-120px",
                ref: scrollHelperRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                width: "100%",
                children: [
                    state.status === model/* QUALIFICATION_STATUS.answering */.w.answering && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedQuestion/* default */.Z, {
                        slides: slides,
                        step: state.qualification.step,
                        highlightColor: highlightColor,
                        ratings: ratings,
                        renderTitle: renderTitle,
                        LayoutComponent: LayoutComponent,
                        titleTranslationKeys: titleTranslationKeys
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        pt: 3
                    }),
                    state.status === model/* QUALIFICATION_STATUS.answered */.w.answered && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIndicator/* default */.Z, {
                                variant: onBackground === "dark" ? "light" : "dark"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                display: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedRequestPage, {
                                    ratings: ratings
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var FormWrapper = styled_components_browser_esm/* default.form */.ZP.form(EmbeddedFunnel_templateObject(), function(param) {
    var $textColor = param.$textColor;
    return $textColor === "light" ? "white" : "rgb(60, 67, 64)";
});
/* harmony default export */ var components_EmbeddedFunnel = (EmbeddedFunnel);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/artifacts/images/shared/qf/variationA/step1.png
/* harmony default export */ var step1 = ({"src":"/_next/static/media/step1.25359a05.png","height":800,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXE8QkA8QkE9Q0E8Qj48QkE8QUA9Q0Bd8AV1AAAACHRSTlMAjkIYLlpvdOkFBQwAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAuSURBVHicPcrJCQAwDAPB6LDdf8chMmRfg9A5P4lclB3QmHqkRkC2Ajoweu/pAg02AF2FLuzIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/qf/variationA/step2.png
/* harmony default export */ var step2 = ({"src":"/_next/static/media/step2.db121146.png","height":800,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVBQUFNTU1JSUlBQUFBQUFBQUFAQEA+Pj5CQkJoHRL9AAAACXRSTlN0AQoam2iJMFVmWw0/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nB3LyQkAMRDEQPUxY+cf8eIFQb2E5D/kQi1Ed4twZ2ZqQg7nMd4rgoCBdyWJ9QEVcQCb3MKLLQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/qf/variationA/step3.png
/* harmony default export */ var step3 = ({"src":"/_next/static/media/step3.7e6043ba.png","height":800,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXE9QUA9QT8+QkA9REA+QUA/Pz/L5cQbAAAAB3RSTlMAhnCcK2QQu/e0iAAAAAlwSFlzAAALEwAACxMBAJqcGAAAACxJREFUeJwtx4EJADAMAsFXk+4/cklaETyBswVHiqFCN6kBDLBAniePV39fLg5qAE2tXUE5AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/shared/qf/variationA/step4.png
/* harmony default export */ var step4 = ({"src":"/_next/static/media/step4.dfc6a89b.png","height":800,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEVMaXE9REQ7QkA7QkA7REE6Q0A6Qj86Qj84QT86QkA4RD7tDis2AAAAC3RSTlMACWunFXxSlTzALTGsGPgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAzSURBVHicHYzJEQAgDITY3Np/wU58wQcAQQiYjpsG2EkLEyhP2gDIPZZUe33pGt8KaQ8PGFcAn1IJ5UIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Steps.tsx

function Steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-direction: column;\n  p {\n    text-align: center;\n    font-size: 10px;\n    ",
        " {\n      font-size: 16px;\n      text-align: left;\n    }\n  }\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    Steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Steps_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  max-width: 1050px;\n  margin: auto;\n  padding: 0 16px;\n  padding-bottom: 16px;\n  gap: 8px;\n  ",
        " {\n    padding: 0;\n    gap: 56px;\n  }\n"
    ]);
    Steps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










function Steps() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: step1,
                        height: 29,
                        width: 29,
                        quality: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        children: t("homepage.variationA.steps.step1")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: step2,
                        height: 29,
                        width: 29,
                        quality: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        children: t("homepage.variationA.steps.step2")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: step3,
                        height: 29,
                        width: 29,
                        quality: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        children: t("homepage.variationA.steps.step3")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: step4,
                        height: 29,
                        width: 29,
                        quality: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        children: t("homepage.variationA.steps.step4")
                    })
                ]
            })
        ]
    });
}
var StepContainer = styled_components_browser_esm/* default.div */.ZP.div(Steps_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StepsWrapper = styled_components_browser_esm/* default.div */.ZP.div(Steps_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});

;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Hero.jsx




function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #7d8f5c;\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: radial-gradient(\n    124.78% 80.11% at 93.04% 116.94%,\n    #e2ec97 7.76%,\n    #e7f4c3 79.45%\n  );\n  position: relative;\n  overflow: hidden;\n  z-index: 2;\n  ",
        " {\n    overflow: visible;\n  }\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: ",
        "px;\n  line-height: 130%;\n\n  ",
        " {\n    font-size: 38px;\n    line-height: 140%;\n  }\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  position: relative;\n  z-index: 1;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Hero_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 14px;\n  white-space: pre-line;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    Hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








function Hero(_param) {
    var ratings = _param.ratings, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "ratings"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var questionRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            as: "section",
            width: "100%",
            id: "heroSection",
            className: "hey15__control"
        }, boxProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container/* default */.Z, {
                        size: "md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            mx: "auto",
                            px: 0,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            maxWidth: {
                                sm: 600,
                                md: 1050
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Title, {
                                variant: "h2",
                                mb: 2,
                                component: "h1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                    t: t,
                                    i18nKey: "homepage.variationA.qf.title",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_StyledTypography, {
                                            variant: "inherit",
                                            component: "inherit"
                                        }, "title"), 
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmbeddedFunnel, {
                        renderTitle: function(title) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_Subtitle, {
                                component: "h2",
                                variant: "subtitle2",
                                children: [
                                    title,
                                    "\xa0"
                                ]
                            });
                        },
                        ratings: ratings,
                        slides: {
                            category: {
                                whiteWrapper: false
                            },
                            dateAndLead: {
                                whiteWrapper: false
                            },
                            dietaryRestriction: {
                                whiteWrapper: false
                            },
                            customerTier: {
                                whiteWrapper: false
                            }
                        },
                        highlightColor: "secondary",
                        onBackground: "light",
                        ref: questionRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {})
                ]
            })
        }))
    });
}
var Hero_StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(Hero_templateObject());
var Hero_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Hero_Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(Hero_templateObject2(), function(param) {
    var mobile = param.mobile;
    return mobile ? 20 : 28;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Content = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject3(), function(props) {
    return props.theme.spacing(4, 0, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(props) {
    return props.theme.spacing(6, 0);
});
var Hero_Subtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(Hero_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/static_pages/home/index.tsx

function home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  ",
        " {\n    gap: 77px;\n  }\n"
    ]);
    home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var CardSelections = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2978), __webpack_require__.e(7841)]).then(__webpack_require__.bind(__webpack_require__, 50863));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50863)
            ];
        }
    }
});
var WhyHeycater = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4052).then(__webpack_require__.bind(__webpack_require__, 4052));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4052)
            ];
        }
    }
});
var Testimonials = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6649), __webpack_require__.e(2978), __webpack_require__.e(9263)]).then(__webpack_require__.bind(__webpack_require__, 82746));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82746)
            ];
        }
    }
});
var WeAreHeycater = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1463).then(__webpack_require__.bind(__webpack_require__, 21463));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21463)
            ];
        }
    }
});
var RightCatering = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2465).then(__webpack_require__.bind(__webpack_require__, 92465));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92465)
            ];
        }
    }
});
var Inspirations = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6727).then(__webpack_require__.bind(__webpack_require__, 36727));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36727)
            ];
        }
    }
});
var CompareSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4391).then(__webpack_require__.bind(__webpack_require__, 14391));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14391)
            ];
        }
    }
});
var Cities = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1344).then(__webpack_require__.bind(__webpack_require__, 81344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81344)
            ];
        }
    }
});
var FAQ = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6649), __webpack_require__.e(5303)]).then(__webpack_require__.bind(__webpack_require__, 96827));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96827)
            ];
        }
    }
});
var CateringsSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8006).then(__webpack_require__.bind(__webpack_require__, 28006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28006)
            ];
        }
    }
});
var BannerImage1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6209).then(__webpack_require__.bind(__webpack_require__, 16209));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16209)
            ];
        }
    }
});
var BannerImage2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6835).then(__webpack_require__.bind(__webpack_require__, 16835));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16835)
            ];
        }
    }
});
function HomePage(param) {
    var ratings = param.ratings;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("homepage.variationA.meta.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("homepage.variationA.meta.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* default */.Z, {
                ratings: ratings,
                hideNavigationLinks: false,
                renderCTA: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        id: "qf-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {
                                ratings: ratings
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogos, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSelections, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyHeycater, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage2, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WeAreHeycater, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightCatering, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Inspirations, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cities, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CateringsSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var home = ((0,context/* withQualificationProvider */.qj)({
    storage: null,
    initialized: true
}, HomePage));
var BodyWrapper = styled_components_browser_esm/* default.div */.ZP.div(home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});

;// CONCATENATED MODULE: ./src/pages/index.tsx




function Home(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(home, (0,_object_spread/* default */.Z)({}, props));
}
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1664,7879,9433,2311,7766,4566,4872,3992,9648,4254,3704,5643,6888,7317,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);